<template>
  <div class="rpr-page" :style="{ '--email-tmpl-w': emailTemplateWidth + 'px' }">
    <div class="rpr-hero">
      <div class="rpr-hero__text">
        <span class="rpr-hero__kicker">Promociones internas</span>
        <h1 class="rpr-hero__title">Convocatorias de promoción</h1>
        <p class="rpr-hero__subtitle">
          Seguimiento con checklist fijo y adjuntos por candidato.
        </p>
      </div>
      <div class="rpr-hero__badge">
        <span>Movilidad interna</span>
      </div>
    </div>

    <v-container fluid class="rpr-container">
      <v-row>
        <!-- <v-col cols="12" lg="5">
          <v-card class="rpr-card" outlined>
            <div class="rpr-card__header">
              <div>
                <h3 class="rpr-card__title">Requerimientos aprobados</h3>
                <span class="rpr-card__hint">Tipo profesional (no masivo)</span>
              </div>
              <s-text
                v-model="reqSearch"
                placeholder="Buscar por campana, area o cargo"
                class="rpr-search"
                dense
              />
            </div>
            <v-data-table
              :headers="reqHeaders"
              :items="filteredRequirements"
              :items-per-page="8"
              class="elevation-0 rpr-table"
              dense
              hide-default-footer
            >
              <template v-slot:item.ReqStatusName="{ item }">
                <v-chip
                  x-small
                  :color="statusColor(item.ReqStatus)"
                  text-color="white"
                >
                  {{ item.ReqStatusName }}
                </v-chip>
              </template>
              <template v-slot:item.ReqEstBudget="{ item }">
                {{ $fun.decrypt(item.ReqEstBudget) }}
              </template>
              <template v-slot:item.Aperture="{ item }">
                <v-btn
                  v-show="$fun.isAdmin() && Number(item.ReqStatus) === 5"
                  x-small
                  color="primary"
                  class="rpr-action"
                  @click="openRecruitment(item)"
                  :loading="
                    openingRecruiting && pendingReqToOpen?.ReqID === item.ReqID
                  "
                >
                  Aperturar
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-col> -->

        <v-col cols="12" lg="12">
          <v-card class="rpr-card" outlined>
            <s-crud-file
              ref="rprCrud"
              no-border
              searchInput
              title="Promociones Internas"
              :config="configRpr"
              :filter="configRpr.filter"
              :folderNavigation="true"
              :folderLabelFields="['RequestedPosition', 'CmpName', 'ReqID']"
              :add="false"
              :edit="false"
              :remove="false"
              with="100%"
              @rowSelected="onRecruitmentSelected"
              @openFolder="openDetail"
            >
              <template v-slot:[`item.AsgAction`]="{ item }">
                <v-btn x-small color="success" @click="openDetail(item)">
                  Detalle
                </v-btn>
              </template>
            </s-crud-file>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
      v-model="detailDialog"
      max-width="1800"
      content-class="rpr-detail-dialog"
      persistent
    >
      <v-card class="rpr-detail">
        <div class="rpr-detail__header">
          <div>
            <h3>Convocatoria #{{ detail?.RprID }}</h3>
            <p>{{ detail?.CmpName }} · {{ detail?.RequestedPosition }}</p>
          </div>
          <v-btn icon @click="detailDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="rpr-detail__body">
          <v-row>
            <v-col cols="12" md="2">
              <div class="rpr-meta">
                <div>
                  <span>Area</span>
                  <strong>{{ detail?.AreName || "-" }}</strong>
                </div>
                <div>
                  <span>Cantidad</span>
                  <strong>{{ detail?.ReqQuantity || "-" }}</strong>
                </div>
                <div>
                  <span>Seleccionados</span>
                  <strong
                    >{{ detail?.SelectedCount || 0 }} /
                    {{ detail?.ReqQuantity || 0 }}</strong
                  >
                </div>
                <div>
                  <span>Vacantes disponibles</span>
                  <strong :style="getVacanciesStyle()">
                    {{
                      Number(detail?.ReqQuantity || 0) -
                      Number(detail?.SelectedCount || 0)
                    }}
                  </strong>
                </div>
                <div>
                  <span>Estado</span>
                  <strong>{{ detail?.RprStatusName || "-" }}</strong>
                </div>
                <div>
                  <span>Candidatos</span>
                  <strong>{{ detail?.TotalCandidates || 0 }}</strong>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="10">
              <!-- Toolbar de acciones rediseñado -->
              <div class="rpr-toolbar">
                <!-- Registrar candidato: solo cuando la convocatoria está Abierta -->
                <v-btn
                  v-show="Number(detail?.RprStatus) === 1"
                  small
                  depressed
                  color="primary"
                  @click="openCandidateDialog"
                >
                  <v-icon small left>mdi-account-plus</v-icon>
                  Registrar candidato
                </v-btn>
                <!-- Archivar convocatoria: solo desde Abierta -->
                <v-btn
                  v-show="$fun.isAdmin() && Number(detail?.RprStatus) === 1"
                  small
                  depressed
                  color="warning"
                  :loading="archivingRecruitment"
                  @click="openArchiveDialog"
                >
                  <v-icon small left>mdi-archive-outline</v-icon>
                  Archivar convocatoria
                </v-btn>
                <!-- Reabrir convocatoria: solo desde Archivada (status 0) -->
                <v-btn
                  v-if="$fun.isAdmin() && Number(detail?.RprStatus) === 0"
                  small
                  depressed
                  color="success"
                  :loading="reopeningRecruitment"
                  @click="reopenRecruitment"
                >
                  <v-icon small left>mdi-lock-open-outline</v-icon>
                  Reabrir convocatoria
                </v-btn>
                <div class="rpr-toolbar__sec">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        small
                        icon
                        color="blue-grey"
                        :loading="loadingHistory"
                        v-on="on"
                        @click="openHistoryDialog"
                      >
                        <v-icon small>mdi-history</v-icon>
                      </v-btn>
                    </template>
                    <span>Historial de cambios de estado</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        small
                        icon
                        :loading="loadingCandidates"
                        v-on="on"
                        @click="loadCandidates"
                      >
                        <v-icon small>mdi-refresh</v-icon>
                      </v-btn>
                    </template>
                    <span>Refrescar candidatos</span>
                  </v-tooltip>
                </div>
              </div>
              <v-data-table
                :headers="candidateHeaders"
                :items="candidates"
                dense
                class="elevation-0 rpr-table"
                :items-per-page="6"
                hide-default-footer
                :loading="loadingCandidates"
              >
                <template v-slot:[`item.FullNames`]="{ item }">
                  <div>
                    <div>{{ item.FullName }}</div>
                    <div class="text-caption text-truncate grey--text">
                      <v-chip
                        x-small
                        :color="statusColor(item.TypeSeeking)"
                        text-color="white"
                      >
                        {{ item.TypeSeekingName }}
                      </v-chip>
                    </div>
                  </div>
                </template>
                <template v-slot:[`item.CurrentStageName`]="{ item }">
                  <div v-if="item.TypeSeeking = 2" class="d-flex align-center" style="gap: 8px; flex-wrap: wrap">
                    <v-chip x-small color="teal" text-color="white">
                      {{ getPromotionChecklistLabel(item) }}
                    </v-chip>
                    <v-btn
                      x-small
                      outlined
                      color="teal"
                      :disabled="!isPromotionCandidate(item)"
                      @click="openPromotionChecklist(item)"
                    >
                      Checklist
                    </v-btn>
                  </div>
                  <div v-else style="display: flex; align-items: center; gap: 3px">
                    <!-- Retroceder etapa -->
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          x-small
                          v-on="on"
                          :disabled="
                            !isRecruitmentOpen ||
                            !isRecruitmentCandidate(item) ||
                            item.CurrentStageID <= 4 ||
                            Number(item.CprStatus) !== 1 ||
                            candidatesReadyForBoss[item.CprID]
                          "
                          @click="retrocederCandidate(item)"
                        >
                          <v-icon x-small color="grey darken-1"
                            >mdi-chevron-left</v-icon
                          >
                        </v-btn>
                      </template>
                      <span>Retroceder etapa</span>
                    </v-tooltip>

                    <v-chip x-small color="#0f766e" text-color="white">
                      {{ item.CurrentStageName }}
                    </v-chip>

                    <!-- Avanzar etapa -->
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          x-small
                          v-on="on"
                          :disabled="
                            !isRecruitmentOpen ||
                            !isRecruitmentCandidate(item) ||
                            Number(item.CprStatus) !== 1 ||
                            Number(item.CurrentStageID) >= 7 ||
                            candidatesReadyForBoss[item.CprID] ||
                            (Number(item.CurrentStageID) === 5 &&
                              !isResponsibleBoss)
                          "
                          @click="advanceCandidate(item)"
                        >
                          <v-icon x-small color="primary"
                            >mdi-chevron-right</v-icon
                          >
                        </v-btn>
                      </template>
                      <span>Avanzar etapa</span>
                    </v-tooltip>
                  </div>
                </template>
                <template v-slot:[`item.CprStatusName`]="{ item }">
                  <v-chip
                    x-small
                    :color="statusColor(item.CprStatus)"
                    text-color="white"
                  >
                    {{ item.CprStatusName || "RECHAZADO" }}
                  </v-chip>
                </template>
                <template v-slot:[`item.Action`]="{ item }">
                  <div style="display: flex; align-items: center; gap: 2px">
                    <!-- Dropdown de acciones -->
                    <v-menu bottom left offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          x-small
                          v-bind="attrs"
                          v-on="on"
                          :disabled="!isPromotionCandidate(item)"
                        >
                          <v-icon small>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <v-list dense class="py-1">
                        <!-- Ver CV -->
                        <v-list-item
                          v-if="item.FileKeyCV"
                          @click="openCandidateCVPreview(item)"
                          dense
                        >
                          <v-list-item-icon class="mr-2 my-auto"
                            ><v-icon small color="indigo"
                              >mdi-file-account-outline</v-icon
                            ></v-list-item-icon
                          >
                          <v-list-item-content
                            ><v-list-item-title class="rpr-menu-item"
                              >Ver CV</v-list-item-title
                            ></v-list-item-content
                          >
                        </v-list-item>
                        <v-list-item
                          @click="openPromotionChecklist(item)"
                          dense
                        >
                          <v-list-item-icon class="mr-2 my-auto"
                            ><v-icon small color="teal"
                              >mdi-format-list-checks</v-icon
                            ></v-list-item-icon
                          >
                          <v-list-item-content
                            ><v-list-item-title class="rpr-menu-item"
                              >Checklist</v-list-item-title
                            ></v-list-item-content
                          >
                        </v-list-item>
                        <v-divider class="my-1" />
                        <!-- Editar: solo cuando abierta -->
                        <v-list-item
                          v-if="isRecruitmentOpen"
                          @click="openEditCandidateDialog(item)"
                          dense
                        >
                          <v-list-item-icon class="mr-2 my-auto"
                            ><v-icon small color="grey darken-1"
                              >mdi-pencil-outline</v-icon
                            ></v-list-item-icon
                          >
                          <v-list-item-content
                            ><v-list-item-title class="rpr-menu-item"
                              >Editar</v-list-item-title
                            ></v-list-item-content
                          >
                        </v-list-item>
                        <v-list-item
                          v-if="
                            isRecruitmentOpen &&
                            Number(item.CprStatus) === 1
                          "
                          @click="selectCandidate(item)"
                          dense
                        >
                          <v-list-item-icon class="mr-2 my-auto"
                            ><v-icon small color="success"
                              >mdi-check-decagram-outline</v-icon
                            ></v-list-item-icon
                          >
                          <v-list-item-content
                            ><v-list-item-title class="rpr-menu-item"
                              >Seleccionar</v-list-item-title
                            ></v-list-item-content
                          >
                        </v-list-item>
                        <v-list-item
                          v-if="
                            isRecruitmentOpen &&
                            Number(item.CprStatus) === 1 &&
                            isPromotionCandidate(item)
                          "
                          @click="rejectCandidate(item)"
                          dense
                        >
                          <v-list-item-icon class="mr-2 my-auto"
                            ><v-icon small color="error"
                              >mdi-close-circle-outline</v-icon
                            ></v-list-item-icon
                          >
                          <v-list-item-content
                            ><v-list-item-title class="rpr-menu-item"
                              >Rechazar</v-list-item-title
                            ></v-list-item-content
                          >
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </template>
                <template v-slot:[`item.Contact`]="{ item }">
                  <div>
                    <div v-if="item.PpnNumberPhone">
                      <v-icon x-small color="primary">mdi-phone</v-icon>
                      <span>{{ item.PpnNumberPhone }}</span>
                    </div>
                    <div v-if="item.PemEmail">
                      <v-icon x-small color="primary">mdi-email</v-icon>
                      <span>{{ item.PemEmail }}</span>
                    </div>
                  </div>
                </template>
              </v-data-table>

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="welcomeDialog" max-width="960" persistent>
      <v-card>
        <div class="rpr-detail__header">
          <div>
            <h3>
              {{
                welcomePreviewReady
                  ? "Previsualización de Bienvenida"
                  : "Fecha de ingreso"
              }}
            </h3>
            <p>{{ selectedCandidate?.FullName || "" }}</p>
          </div>
          <v-btn
            icon
            @click="closeWelcomeDialog"
            :disabled="sendingWelcomeEmail"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <!-- Paso 1: Fecha de inicio -->
          <div v-if="!welcomePreviewReady">
            <v-text-field
              v-model="welcomeStartDate"
              label="Fecha de inicio"
              type="date"
              outlined
              dense
            />
          </div>

          <!-- Paso 2: Previsualización + Adjuntos -->
          <div v-else>
            <div class="welcome-preview-container">
              <h4 class="mb-3">Vista previa de la imagen de bienvenida:</h4>
              <div class="welcome-preview-box">
                <img
                  v-if="welcomePreviewImageDataUrl"
                  :src="welcomePreviewImageDataUrl"
                  alt="Preview bienvenida"
                  class="welcome-preview-image"
                />
                <div
                  v-else
                  ref="welcomeTemplatePreview"
                  class="welcome-template-preview"
                  v-html="welcomeTemplateHtml"
                ></div>
              </div>
            </div>

            <v-file-input
              v-model="welcomeAdditionalFiles"
              label="Adjuntos adicionales (opcional)"
              multiple
              show-size
              outlined
              dense
              prepend-icon="mdi-paperclip"
              class="mt-4"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="closeWelcomeDialog"
            :disabled="sendingWelcomeEmail"
            >Cancelar</v-btn
          >
          <v-btn
            v-if="!welcomePreviewReady"
            color="primary"
            :loading="generatingPreview"
            @click="generateWelcomePreview"
          >
            Previsualizar
          </v-btn>
          <v-btn
            v-else
            color="success"
            :loading="sendingWelcomeEmail"
            @click="confirmCandidateSelection"
          >
            {{
              welcomeIsResend ? "Reenviar notificación" : "Confirmar y enviar"
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Template oculto para captura final -->
    <div class="welcome-template-wrapper">
      <div
        ref="welcomeTemplate"
        class="welcome-template-render"
        v-html="welcomeTemplateHtml"
      ></div>
    </div>

    <!-- Dialog para rechazo de candidato -->
    <v-dialog v-model="rejectionDialog" max-width="960" persistent>
      <v-card>
        <div class="rpr-detail__header">
          <div>
            <h3>
              {{
                rejectionPreviewReady
                  ? "Previsualización de Rechazo"
                  : "Confirmar rechazo"
              }}
            </h3>
            <p>{{ selectedCandidate?.FullName || "" }}</p>
          </div>
          <v-btn
            icon
            @click="closeRejectionDialog"
            :disabled="sendingRejectionEmail"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <!-- Paso 1: Confirmación -->
          <div v-if="!rejectionPreviewReady">
            <p class="mb-4">
              ¿Estás seguro de que deseas rechazar a este candidato? Se enviará
              un correo informando la decisión.
            </p>
          </div>

          <!-- Paso 2: Previsualización -->
          <div v-else>
            <div class="welcome-preview-container">
              <h4 class="mb-3">Vista previa de la imagen de rechazo:</h4>
              <div class="welcome-preview-box">
                <img
                  v-if="rejectionPreviewImageDataUrl"
                  :src="rejectionPreviewImageDataUrl"
                  alt="Preview rechazo"
                  class="welcome-preview-image"
                />
                <div
                  v-else
                  ref="rejectionTemplatePreview"
                  class="rejection-template-preview"
                  v-html="rejectionTemplateHtml"
                ></div>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="closeRejectionDialog"
            :disabled="sendingRejectionEmail"
            >Cancelar</v-btn
          >
          <v-btn
            v-if="!rejectionPreviewReady"
            color="warning"
            :loading="generatingRejectionPreview"
            @click="generateRejectionPreview"
          >
            Ver previsualización
          </v-btn>
          <v-btn
            v-else
            color="error"
            :loading="sendingRejectionEmail"
            @click="confirmRejectionSelection"
          >
            Confirmar rechazo y enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Template oculto para captura rejection -->
    <div class="rejection-template-wrapper">
      <div
        ref="rejectionTemplate"
        class="rejection-template-render"
        v-html="rejectionTemplateHtml"
      ></div>
    </div>

    <div class="archive-template-wrapper">
      <div
        ref="archiveTemplate"
        class="archive-template-render"
        v-html="archiveTemplateHtml"
      ></div>
    </div>

    <!-- Dialog para registrar candidato -->
    <v-dialog v-model="candidateDialog" max-width="760" persistent>
      <v-card class="rpr-candidate">
        <div class="rpr-detail__header">
          <div>
            <h3>
              {{
                isEditingCandidate ? "Editar candidato" : "Registrar candidato"
              }}
            </h3>
            <p>{{ detail?.RequestedPosition || "" }}</p>
          </div>
          <v-btn icon @click="closeCandidateDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <s-toolbar-person
                v-if="!isEditingCandidate"
                noCamera
                :addTypeSex="true"
                :typeperson="1"
                @returnPerson="onPersonSelected"
              />
              <v-alert v-else dense outlined type="info" class="mb-0">
                En edición no se cambia la persona asociada.
              </v-alert>
            </v-col>
            <!-- Alerta visual si el postulante tiene restricción laboral -->
            <v-col v-if="candidateAdmonition" cols="12" class="py-1">
              <v-alert
                prominent
                type="error"
                border="left"
                class="mb-2 rounded-lg"
                elevation="2"
              >
                <div class="d-flex align-center justify-space-between flex-wrap">
                  <div>
                    <div class="font-weight-bold subtitle-1 d-flex align-center">
                      <v-icon left color="white">mdi-alert-octagon</v-icon>
                      ¡POSTULANTE CON RESTRICCIÓN LABORAL!
                    </div>
                    <div class="caption mt-1">
                      <strong>Tipo:</strong>
                      {{
                        candidateAdmonition.TypeAdmonitionName ||
                        candidateAdmonition.TypeAdmonitionText ||
                        "Falta Grave / Suspensión"
                      }}
                      <span v-if="candidateAdmonition.AdmDate">
                        | <strong>Fecha:</strong>
                        {{ candidateAdmonition.AdmDate }}</span
                      >
                    </div>
                    <div
                      v-if="candidateAdmonition.AdmObservation"
                      class="caption mt-1"
                    >
                      <strong>Falta / Observación:</strong>
                      {{ candidateAdmonition.AdmObservation }}
                    </div>
                  </div>
                  <v-btn
                    small
                    depressed
                    color="white"
                    class="red--text text--darken-3 font-weight-bold ml-auto mt-2 mt-sm-0"
                    @click="showAdmonitionDetailDialog = true"
                  >
                    <v-icon left small>mdi-eye</v-icon> Ver Detalle Completo
                  </v-btn>
                </div>
              </v-alert>
            </v-col>
            <!-- Indicador de carga de datos previos -->
            <v-col v-if="loadingPreviousData" cols="12" class="py-1">
              <v-progress-linear
                indeterminate
                color="primary"
                rounded
                height="3"
              />
              <span class="caption grey--text"
                >Cargando datos de aplicación anterior...</span
              >
            </v-col>
            <!-- v-text para visualizar el nombre del candidato -->
            <v-col cols="12" md="6">
              <s-text
                label="Candidato"
                :value="
                  candidateForm.PrsID
                    ? `${candidateForm.FullName} (${candidateForm.PrsDocumentNumber})`
                    : ''
                "
                disabled
              />
            </v-col>
            <v-col cols="12" md="6">
              <s-select-definition
                :def="1521"
                label="Fuente"
                v-model="candidateForm.SourceID"
                :add-custom="$fun.isAdmin()"
                :customFields="[
                  {
                    key: 'DedDescription',
                    label: 'Nombre',
                    required: true,
                    cols: 6,
                  },
                ]"
              />
            </v-col>
            <v-col cols="12" md="6">
              <s-text
                label="Información Adicional"
                v-model="candidateForm.SourceDetail"
              />
            </v-col>
            <v-col cols="12" md="12">
              <v-row>
                <v-col cols="12" md="5">
                  <s-text
                    label="Teléfono *"
                    v-model="candidateForm.Phone"
                    number
                    :maxlength="9"
                    :counter="9"
                    :rules="[
                      (v) => !!v || 'Campo obligatorio',
                      (v) => (v && v.length === 9) || 'Debe tener 9 dígitos',
                    ]"
                  />
                </v-col>
                <v-col cols="12" md="7">
                  <s-select-definition
                    :def="1111"
                    label="Tipo *"
                    v-model="candidateForm.TypePhone"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="12">
              <v-row>
                <v-col cols="12" md="7">
                  <s-text
                    label="Correo (usuario) *"
                    v-model="candidateForm.EmailUser"
                    type="text"
                    :rules="[
                      (v) => !!v || 'Campo obligatorio',
                      (v) =>
                        /^[a-zA-Z0-9._-]+$/.test(v) ||
                        'Solo letras, números y puntos',
                    ]"
                    hint="Ej: juan.perez"
                  />
                </v-col>
                <v-col cols="12" md="5">
                  <s-select-definition
                    :def="1518"
                    label="Dominio *"
                    v-model="candidateForm.EmailDomain"
                    :add-custom="$fun.isAdmin()"
                    :customFields="[
                      {
                        key: 'DedDescription',
                        label: 'Nombre',
                        required: true,
                        cols: 6,
                      },
                    ]"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="6">
              <div
                class="d-flex align-center mb-2"
                v-if="candidateForm.FileKeyCV"
              >
                <v-btn
                  x-small
                  text
                  color="indigo"
                  @click="openCandidateCVPreview(candidateForm)"
                >
                  Ver CV actual
                </v-btn>
                <span
                  class="ml-2 grey--text text--darken-1"
                  style="font-size: 12px"
                >
                  {{ candidateForm.FileKeyCV }}
                </span>
              </div>
              <s-load
                :label="isEditingCandidate ? 'Reemplazar CV (opcional)' : 'CV'"
                v-model="candidateFile"
                pdf
                clearable
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="rpr-actions">
          <v-spacer />
          <v-btn text @click="candidateDialog = false">Cancelar</v-btn>
          <v-btn
            color="primary"
            :loading="savingCandidate"
            @click="saveCandidate"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <hmn-candidate-file-preview-dialog
      v-model="candidateCVPreviewDialog"
      :preview-type="candidateCVPreviewType"
      :preview-url="candidateCVPreviewUrl"
      :can-download="!!candidateCVPreviewFileName"
      @download="downloadCandidateCV"
      @close="closeCandidateCVPreview"
    />

    <hmn-promotion-checklist-dialog
      v-model="promotionChecklistDialog"
      :candidate="promotionChecklistCandidate"
      @summary="onPromotionChecklistSummary"
      @close="promotionChecklistCandidate = null"
    />

    <!-- Dialog para ver detalle de amonestación / restricción -->
    <hmn-admonition-detail-dialog
      v-model="showAdmonitionDetailDialog"
      :applicant="applicantAdmonitionData"
    />

    <!-- Componente para responder preguntas de entrevista -->
    <hmn-interview-responses-form
      v-model="answerQuestionsDialog"
      :questions="interviewQuestions"
      :all-questions="cachedQuestions"
      :rpr-i-d="currentRprID"
      :loading="advancingCandidate"
      @confirm="confirmAdvanceWithAnswers"
      @cancel="onAnswersCancel"
    />

    <!-- Dialog para ver respuestas de entrevista -->
    <v-dialog v-model="responsesDialog" max-width="650">
      <v-card>
        <v-card-title class="headline">
          Respuestas de entrevista preliminar
        </v-card-title>
        <v-card-text>
          <div v-if="loadingResponses" class="text-center py-4">
            <v-progress-circular indeterminate color="primary" />
          </div>
          <div
            v-else-if="interviewResponses.length === 0"
            class="text-center py-4"
          >
            <p class="grey--text">No hay respuestas registradas</p>
          </div>
          <v-simple-table v-else dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Pregunta</th>
                  <th class="text-left">Respuesta</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="response in interviewResponses"
                  :key="response.CirID"
                >
                  <td>
                    <strong>{{ getQuestionText(response.ColumnName) }}</strong>
                  </td>
                  <td>{{ response.Value || "-" }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="responsesDialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Componente para seleccionar preguntas preliminares -->
    <hmn-questions-selector
      v-model="questionsDialog"
      :loading="openingRecruiting"
      @confirm="confirmRecruitmentOpening"
      @cancel="onQuestionsCancel"
      @questions-loaded="onQuestionsLoaded"
    />

    <!-- Dialog para aprobación de candidatos por jefe de área (Etapa 5) -->
    <v-dialog v-model="bossApprovalDialog" max-width="1400" persistent>
      <hmn-boss-interview-approval
        v-if="detail?.RprID"
        :rpr-i-d="detail.RprID"
        @close="bossApprovalDialog = false"
      />
    </v-dialog>

    <!-- Dialog para archivar convocatoria -->
    <v-dialog v-model="archiveDialog" max-width="520" persistent>
      <v-card>
        <v-card-title class="headline">
          <v-icon left color="warning">mdi-archive-outline</v-icon>
          Archivar convocatoria
        </v-card-title>
        <v-card-text>
          <p class="mb-2">Esta acción archivará la convocatoria. Se notificará por correo a los candidatos que respondieron las preguntas preliminares.</p>
          <v-textarea
            v-model="archiveObservation"
            label="Observación (obligatoria)"
            outlined
            dense
            rows="3"
            counter
            maxlength="500"
            :rules="[v => !!v && !!v.trim() || 'La observación es obligatoria']"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="archiveDialog = false">Cancelar</v-btn>
          <v-btn
            color="warning"
            depressed
            :loading="archivingRecruitment"
            :disabled="!archiveObservation || !archiveObservation.trim()"
            @click="confirmArchive"
          >
            <v-icon left>mdi-archive-outline</v-icon>
            Confirmar archivo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog historial de cambios de estado -->
    <v-dialog v-model="historyDialog" max-width="780">
      <v-card>
        <v-card-title class="headline">
          <v-icon left color="blue-grey">mdi-history</v-icon>
          Historial de estados
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="[
              { text: 'Fecha', value: 'ActionDate', width: '140' },
              { text: 'Estado anterior', value: 'PreviousStatusName', width: '120' },
              { text: 'Estado nuevo', value: 'NewStatusName', width: '120' },
              { text: 'Observación', value: 'Observation' },
              { text: 'Usuario', value: 'UserActionName', width: '140' },
            ]"
            :items="historyItems"
            :loading="loadingHistory"
            dense
            hide-default-footer
            :items-per-page="-1"
          >
            <template v-slot:[`item.ActionDate`]="{ item }">
              {{ item.ActionDate ? item.ActionDate.substring(0, 16).replace('T', ' ') : '' }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="historyDialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SLoad from "@/components/Utils/SLoad.vue";
import SToolbarPerson from "@/components/Utils/Person/sToolbarPerson.vue";
import HmnQuestionsSelector from "./HmnQuestionsSelector.vue";
import HmnInterviewResponsesForm from "./HmnInterviewResponsesForm.vue";
import HmnPromotionChecklistDialog from "./HmnPromotionChecklistDialog.vue";
import HmnCandidateFilePreviewDialog from "./HmnCandidateFilePreviewDialog.vue";
import HmnAdmonitionDetailDialog from "@/components/HumanResource/Recruitment/HmnAdmonitionDetailDialog.vue";
import HmnRecruitmentProcessService from "@/services/HumanResource/RecruitmentProcess/HmnRecruitmentProcessService";
import HmnCandidateProcessService from "@/services/HumanResource/RecruitmentProcess/HmnCandidateProcessService";
import StaffingRequirementService from "@/services/HumanResource/RecruitmentSelection/HmnStaffingRequirement";
import _sAdmonition from "@/services/HumanResource/AdmonitionService";
import PersonService from "@/services/General/PersonService";
import GenUploadFiles from "@/services/General/GenUploadFiles";
import GenPersonTelephoneService from "@/services/General/GenPersonTelephoneService";
import GenPersonEmailService from "@/services/General/GenPersonEmailService";
import GenEmailService from "@/services/General/GenEmailService";
import DefinitionService from "@/services/General/DefinitionService";
import _sGenParam from "@/services/General/ParameterService";
import { exportVuetifyToExcel } from "@/utils/excelExport";
import html2canvas from "html2canvas";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import { PDFDocument } from "pdf-lib";

const EMAIL_TEMPLATE_WIDTH = 680;

pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

export default {
  name: "HmnPromotionProcessView",
  components: {
    SLoad,
    SToolbarPerson,
    HmnQuestionsSelector,
    HmnInterviewResponsesForm,
    HmnBossInterviewApproval,
    HmnPromotionChecklistDialog,
    HmnCandidateFilePreviewDialog,
    HmnAdmonitionDetailDialog,
  },
  data() {
    return {
      emailTemplateWidth: EMAIL_TEMPLATE_WIDTH,
      reqSearch: "",
      requirements: [],
      exportingInterviewResponses: false,
      detailDialog: false,
      candidateDialog: false,
      candidateAdmonition: null,
      showAdmonitionDetailDialog: false,
      checkingAdmonition: false,
      questionsDialog: false,
      answerQuestionsDialog: false,
      responsesDialog: false,
      bossApprovalDialog: false,
      promotionChecklistDialog: false,
      promotionChecklistCandidate: null,
      promotionChecklistSummary: {},
      pendingReqToOpen: null,
      pendingAdvance: null,
      selectedCandidate: null,
      advancingCandidate: false,
      openingRecruiting: false,
      welcomeDialog: false,
      sendingWelcomeEmail: false,
      generatingPreview: false,
      welcomePreviewReady: false,
      welcomeStartDate: "",
      welcomeAdditionalFiles: [],
      welcomeIsResend: false,
      welcomeMailData: null,
      welcomeTemplateHtmlRaw: "",
      welcomeTemplateHtml: "",
      welcomePreviewImageDataUrl: "",
      welcomePreviewImageBytes: "",
      welcomePdfAttachments: [],
      welcomeAssetsLoaded: false,
      welcomeBackgroundImageDataUrl: "/static/WelcomeBGTemplate.png",
      welcomeLogoUrl: "/static/logo_sp.png",
      rejectionDialog: false,
      sendingRejectionEmail: false,
      generatingRejectionPreview: false,
      rejectionPreviewReady: false,
      rejectionTemplateHtmlRaw: "",
      rejectionTemplateHtml: "",
      rejectionPreviewImageDataUrl: "",
      rejectionPreviewImageBytes: "",
      rejectionAssetsLoaded: false,
      rejectionBackgroundImageDataUrl: "/static/WelcomeBGTemplate.png",
      rejectionLogoUrl: "/static/logo_sp.png",
      rejectionMailData: null,
      archiveTemplateHtmlRaw: "",
      archiveTemplateHtml: "",
      archiveAssetsLoaded: false,
      archiveBackgroundImageDataUrl: "",
      archiveLogoUrl: "/static/logo_sp.png",
      interviewQuestions: [],
      interviewResponses: [],
      loadingResponses: false,
      personLookupSeq: 0,
      interviewExportColumns: [
        { value: "PrsDocumentNumber", text: "Documento" },
        { value: "CandidateName", text: "Nombre del Candidato" },
        { value: "Age", text: "Años" },
        { value: "CurrentStageName", text: "Etapa Actual" },
        { value: "CprStatusName", text: "Estado de postulante" },
        { value: "CurrentResidence", text: "Residencia" },
        { value: "ChangeResidence", text: "Cambio de Residencia" },
        { value: "Availability", text: "disponibilidad" },
        { value: "Working", text: "Laborando" },
        { value: "ProminentCompanies", text: "Empresas Destacadas" },
        { value: "Experience", text: "Experiencia (años)" },
        { value: "ReferenceContact", text: "Contacto de Referencia" },
        { value: "ProfessionalProfile", text: "Perfil Profesional" },
        { value: "ExperienceDescription", text: "Descripcion de Experiencia." },
        { value: "CurrentSalary", text: "Salario Actual" },
        { value: "SalaryExpectation", text: "Expectativa salarial" },
      ],
      questionsMap: {}, // ✅ Mapeo de ID pregunta -> descripción
      cachedQuestions: [], // ✅ Cache de DefID 1661
      currentRprID: 0, // ✅ RprID actual para obtener preguntas específicas
      candidatesReadyForBoss: {}, // { [CprID]: true } — sala de espera (filtro visual)
      selectedForBoss: [], // candidatos seleccionados para enviar en lote
      sendingToBoss: false,
      salaHeaders: [
        { text: "Nombre", value: "FullName" },
        { text: "Documento", value: "PrsDocumentNumber", width: 110 },
        { text: "Etapa", value: "CurrentStageName", width: 110 },
        { text: "", value: "sala_remove", sortable: false, width: 40 },
      ],
      detail: null,
      candidates: [],
      loadingCandidates: false,
      loadingPreviousData: false,
      savingCandidate: false,
      updatingRecruitmentStatus: false,
      isEditingCandidate: false,
      // Archive dialog
      archiveDialog: false,
      archiveObservation: "",
      archivingRecruitment: false,
      reopeningRecruitment: false,
      // History dialog
      historyDialog: false,
      historyItems: [],
      loadingHistory: false,
      candidateCVPreviewDialog: false,
      candidateCVPreviewUrl: null,
      candidateCVPreviewType: null,
      candidateCVPreviewFileName: null,
      candidateFile: null,
      candidateForm: {
        CprID: 0,
        RprID: 0,
        PrsID: 0,
        PstID: 0,
        TypeSeeking: 2,
        CurrentStageID: 2,
        CprStatus: 1,
        SecStatus: 1,
        CprReadyForBoss: false,
        PpnID: 0,
        PemID: 0,
        SourceID: null,
        SourceDetail: "",
        FileKeyCV: null,
        Phone: "",
        TypePhone: 1,
        EmailUser: "",
        EmailDomain: 1,
        TypeDomainEmail: 1,
      },
      reqHeaders: this.$fun.isAdmin()
        ? [
            { text: "ID", value: "ReqID", width: 70 },
            { text: "Campana", value: "CmpName" },
            { text: "Area", value: "AreName" },
            { text: "Cargo", value: "PstName" },
            { text: "Estado", value: "ReqStatusName" },
            { text: "Presupuesto", value: "ReqEstBudget", width: 120 },
            { text: "Apertura", value: "Aperture", sortable: false, width: 90 },
          ]
        : [
            { text: "Campana", value: "CmpName" },
            { text: "Area", value: "AreName" },
            { text: "Cargo", value: "PstName" },
            { text: "Estado", value: "ReqStatusName" },
          ],
      candidateHeaders: [
        { text: "Nombre", value: "FullNames" },
        { text: "Documento", value: "PrsDocumentNumber", width: 120 },
        { text: "Checklist", value: "CurrentStageName", width: 210 },
        { text: "Estado", value: "CprStatusName", width: 120 },
        { text: "Contacto", value: "Contact", width: 120 },
        { text: "", value: "Action", sortable: false, width: 50 },
      ],
      configRpr: {
        filter: { ModuleType: 2 },
        model: {
          RprID: "ID",
          OpenDate: "datetime",
          ReqQuantity: "number",
          TotalCandidates: "number",
          SelectedCount: "number",
          AsgAction: "",
        },
        service: HmnRecruitmentProcessService,
        headers: [
          { text: "ID", value: "RprID", width: 70 },
          { text: "Campana", value: "CmpName" },
          { text: "Cargo", value: "RequestedPosition" },
          { text: "Area", value: "AreName" },
          { text: "Estado", value: "RprStatusName" },
          { text: "Candidatos", value: "TotalCandidates" },
          { text: "Seleccionados", value: "SelectedCount" },
          { text: "Acciones", value: "AsgAction", sortable: false, width: 90 },
        ],
      },
    };
  },
  computed: {
    applicantAdmonitionData() {
      if (!this.candidateAdmonition) return null;
      return {
        FullName: this.candidateForm.FullName,
        PrsDocumentNumber: this.candidateForm.PrsDocumentNumber,
        TypeAdmonitionText:
          this.candidateAdmonition.TypeAdmonitionName ||
          this.candidateAdmonition.TypeAdmonitionText,
        AdmObservation: this.candidateAdmonition.AdmObservation,
        AdmReason: this.candidateAdmonition.AdmReason,
        AdmDate: this.candidateAdmonition.AdmDate,
        AdmDateStart: this.candidateAdmonition.AdmDateStart,
        AdmDateFinish: this.candidateAdmonition.AdmDateFinish,
      };
    },
    filteredRequirements() {
      const term = this.reqSearch.trim().toLowerCase();
      return this.requirements.filter((item) => {
        if (!term) return true;
        const data = [item.CmpName, item.AreName, item.PstName, item.ReqID]
          .join(" ")
          .toLowerCase();
        return data.includes(term);
      });
    },
    welcomeTemplateBackgroundStyle() {
      if (!this.welcomeBackgroundImageDataUrl) {
        return { background: "#ffffff" };
      }

      return {
        // backgroundImage: `url('${this.welcomeBackgroundImageDataUrl}')`,
        backgroundSize: "cover",
        backgroundPosition: "center bottom",
        backgroundRepeat: "no-repeat",
        backgroundColor: "#ffffff",
      };
    },
    isResponsibleBoss() {
      const PstID = this.$fun.getUserInfo().CtrContract?.PstID || 0;
      return this.detail?.PstResponsibleID === PstID;
    },
    isRecruitmentOpen() {
      return Number(this.detail?.RprStatus) === 1;
    },
    candidatesReadyInSala() {
      return this.candidates.filter(
        (c) => this.candidatesReadyForBoss[c.CprID]
      );
    },
  },
  created() {
    this.loadRequirements();
  },
  methods: {
    getInterviewExportColumns(rows) {
      const availableColumns = Object.keys(rows?.[0] || {});
      const configuredColumns = Array.isArray(this.interviewExportColumns)
        ? this.interviewExportColumns.filter((column) => column && column.value)
        : [];

      if (!configuredColumns.length) {
        return availableColumns.map((key) => ({ value: key, text: key }));
      }

      return configuredColumns.filter((column) =>
        availableColumns.includes(column.value)
      );
    },
    mapInterviewRowsForExport(rows, columns) {
      return rows.map((row) => {
        const exportRow = {};

        columns.forEach((column) => {
          const headerText = String(column.text || column.value || "").trim();
          if (!headerText) return;
          exportRow[headerText] = row[column.value];
        });

        return exportRow;
      });
    },
    async exportInterviewResponsesByRequirement() {
      if (!this.detail?.ReqID) {
        this.$fun.alert("No se encontró el requerimiento", "warning");
        return;
      }

      this.exportingInterviewResponses = true;
      try {
        const response =
          await HmnRecruitmentProcessService.ExportInterviewByRequirement(
            this.detail.ReqID,
            this.$fun.getUserID()
          );

        const rows = Array.isArray(response?.data) ? response.data : [];
        if (!rows.length) {
          this.$fun.alert("No hay datos para exportar", "warning");
          return;
        }

        const columns = this.getInterviewExportColumns(rows);

        if (!columns.length) {
          this.$fun.alert(
            "Las columnas configuradas no existen en la data a exportar",
            "warning"
          );
          return;
        }

        const exportRows = this.mapInterviewRowsForExport(rows, columns);
        const headers = columns.map((column) => ({
          text: column.text,
          value: column.text,
        }));

        await exportVuetifyToExcel(headers, exportRows, {
          title: `Respuestas entrevista - Convocatoria ${this.detail.RprID}`,
          subtitle: `${this.detail?.CmpName || ""} - ${
            this.detail?.RequestedPosition || ""
          }`,
          filename: `Respuestas_Entrevista_Convocatoria_${this.detail.RprID}`,
          color: "B45309",
          minWidth: 10,
          maxWidth: 60,
        });
      } catch (error) {
        this.$fun.alert("No se pudieron exportar las respuestas", "error");
      } finally {
        this.exportingInterviewResponses = false;
      }
    },
    statusColor(status) {
      if (status === 2) return "#0f766e";
      if (status === 0) return "#b91c1c";
      return "#334155";
    },
    getVacanciesStyle() {
      const remaining =
        Number(this.detail?.ReqQuantity || 0) -
        Number(this.detail?.SelectedCount || 0);
      if (remaining <= 0) {
        return "color: #b91c1c; font-weight: bold;"; // Rojo: sin vacantes
      } else if (remaining <= 1) {
        return "color: #ea580c; font-weight: bold;"; // Naranja: última vacante
      }
      return "";
    },
    async loadRequirements() {
      try {
        const response = await StaffingRequirementService.list(
          this.$fun.getUserID()
        );
        if (response.status === 200) {
          this.requirements = response.data.filter((req) => {
            return (
              Number(req.TypeRequirement) !== 2 && Number(req.ReqStatus) === 5
            );
          });
        }
      } catch (error) {
        this.$fun.alert("No se pudieron cargar los requerimientos", "error");
      }
    },
    async updateRecruitmentStatus(nextStatus, successMessage) {
      if (!this.detail?.RprID) {
        this.$fun.alert("No se encontró la convocatoria", "warning");
        return;
      }

      this.updatingRecruitmentStatus = true;
      try {
        const payload = {
          RprID: this.detail.RprID,
          RprStatus: nextStatus,
          RprCancelReason: null,
        };

        await HmnRecruitmentProcessService.update(
          payload,
          this.$fun.getUserID()
        );
        this.$fun.alert(successMessage, "success");
        await this.loadDetail(this.detail.RprID);
        this.$refs.rprCrud.refresh();
        this.loadRequirements();
      } catch (error) {
        this.$fun.alert(
          error?.response?.data || "No se pudo actualizar la convocatoria",
          "warning"
        );
      } finally {
        this.updatingRecruitmentStatus = false;
      }
    },
    // openArchiveDialog abre el diálogo de observación obligatoria
    openArchiveDialog() {
      this.archiveObservation = "";
      this.archiveAssetsLoaded = false;
      this.archiveDialog = true;
    },
    buildScopedTemplateHtml(html, wrapperClass) {
      let scopedHtml = html || "";
      let scopedStyle = "";
      const styleMatches = [
        ...scopedHtml.matchAll(/<style[^>]*>([\s\S]*?)<\/style>/gi),
      ];
      if (styleMatches.length) {
        const rawCss = styleMatches.map((m) => m[1] || "").join("\n");
        const prefixedCss = rawCss.replace(
          /(^|})\s*([^@{}][^{]+)\{/g,
          (full, brace, selectors) => {
            const scopedSelectors = selectors
              .split(",")
              .map((selector) => {
                const normalizedSelector = selector.trim();
                if (!normalizedSelector) return normalizedSelector;
                if (normalizedSelector.startsWith(`.${wrapperClass}`)) {
                  return normalizedSelector;
                }
                if (
                  normalizedSelector === "body" ||
                  normalizedSelector === "html" ||
                  normalizedSelector === ":root"
                ) {
                  return `.${wrapperClass}`;
                }
                return `.${wrapperClass} ${normalizedSelector}`;
              })
              .join(", ");
            return `${brace} ${scopedSelectors} {`;
          }
        );

        scopedStyle = `<style>${prefixedCss}</style>`;
      }

      scopedHtml = scopedHtml.replace(/<head[^>]*>[\s\S]*?<\/head>/gi, "");
      scopedHtml = scopedHtml.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "");
      scopedHtml = scopedHtml.replace(/<!DOCTYPE[^>]*>/gi, "");
      scopedHtml = scopedHtml.replace(/<html[^>]*>/gi, "");
      scopedHtml = scopedHtml.replace(/<\/html>/gi, "");
      scopedHtml = scopedHtml.replace(/<body[^>]*>/gi, "");
      scopedHtml = scopedHtml.replace(/<\/body>/gi, "");

      return scopedStyle ? `${scopedStyle}${scopedHtml}` : scopedHtml;
    },
    async ensureArchiveAssetsLoaded(forceReload = false) {
      if (this.archiveAssetsLoaded && !forceReload) return;
      const response = await HmnCandidateProcessService.getArchiveAssets(
        this.$fun.getUserID()
      );

      if (response.status !== 200) {
        throw new Error("No se pudo cargar la plantilla de archivado");
      }

      this.archiveTemplateHtmlRaw = response.data?.TemplateHtml || "";
      this.archiveBackgroundImageDataUrl =
        response.data?.BackgroundImageDataUrl || "";
      this.archiveAssetsLoaded = true;
    },
    renderArchiveTemplate(mailData) {
      let html = this.archiveTemplateHtmlRaw || "";

      const toTitle = (str) =>
        str ? str.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase()) : "";

      html = html.replace(/\{\{\s*candidateName\s*\}\}/gi, toTitle(mailData.FullName));
      html = html.replace(/\{\{\s*fullName\s*\}\}/gi, toTitle(mailData.FullName));
      html = html.replace(/\{\{\s*firstName\s*\}\}/gi, toTitle(mailData.FirstName || mailData.FullName));
      html = html.replace(/\{\{\s*positionName\s*\}\}/gi, mailData.PositionName || "");
      html = html.replace(/\{\{\s*logoUrl\s*\}\}/gi, this.archiveLogoUrl);
      html = html.replace(/\{\{\s*backgroundImageUrl\s*\}\}/gi, "");

      html = this.buildScopedTemplateHtml(html, "archive-template-render");

      this.archiveTemplateHtml = html;
    },
    async buildArchiveImageBytes() {
      const element = this.$refs.archiveTemplate;
      if (!element) {
        throw new Error("Elemento archive-template-render no encontrado");
      }

      // Aplicar fondo directamente al elemento capturado por html2canvas
      if (this.archiveBackgroundImageDataUrl) {
        element.style.backgroundImage = `url('${this.archiveBackgroundImageDataUrl}')`;
        element.style.backgroundSize = "cover";
        element.style.backgroundPosition = "center center";
        element.style.backgroundRepeat = "no-repeat";
      }

      if (document.fonts?.ready) {
        await Promise.race([
          document.fonts.ready,
          new Promise((resolve) => setTimeout(resolve, 1200)),
        ]);
      }

      const captureScale = Math.max(2, window.devicePixelRatio || 1);
      const blob = await html2canvas(element, {
        allowTaint: true,
        useCORS: true,
        backgroundColor: null,
        scale: captureScale,
      }).then((canvas) => {
        return new Promise((resolve) => {
          canvas.toBlob(resolve, "image/png");
        });
      });

      if (!blob) throw new Error("No se pudo generar la imagen de archivado");

      return this.blobToBase64(blob);
    },
    async sendArchiveNotifications() {
      const recipientsRes = await HmnRecruitmentProcessService.archiveEmailRecipients(
        this.detail.RprID,
        this.$fun.getUserID()
      );
      const recipients = Array.isArray(recipientsRes.data)
        ? recipientsRes.data.filter((candidate) => !!candidate.PemEmail)
        : [];

      const positionName = this.detail?.RequestedPosition || "";
      await this.ensureArchiveAssetsLoaded(true);
      for (const candidate of recipients) {        
        const fullName =
          candidate.FullName || candidate.PrsFullName || "candidato/a";
        const firstName =
          candidate.FirstName ||
          candidate.NtpName ||
          fullName.split(" ").pop() ||
          fullName;
        const mailData = {
          FullName: fullName,
          FirstName: firstName,
          PositionName: positionName,
        };

        this.renderArchiveTemplate(mailData);
        await this.$nextTick();

        const archiveImageBytes = await this.buildArchiveImageBytes();
        const safeName = (fullName || "Candidato").replace(/\s+/g, "_");
        const mailPayload = {
          emailTo: candidate.PemEmail,
          subject: `Comunicado sobre proceso de selección - ${positionName}`,
          bodyMail: `
            <p><img src="cid:ArchiveNotification" style="width: ${EMAIL_TEMPLATE_WIDTH}px; max-width: 100%;" /></p>
          `,
          useRecruitmentParamConfig: true,
          includeDefaultTemplateAttachments: false,
          attachments: [
            {
              attachmentBytes: archiveImageBytes,
              nameFile: `Proceso_Archivado.png`,
              contentId: "ArchiveNotification",
            },
          ],
        };

        const enqueueResponse = await GenEmailService.sendEmailWithAttach(
          mailPayload,
          this.$fun.getUserID()
        );

        if (
          enqueueResponse?.status !== 200 ||
          enqueueResponse?.data?.queued !== true
        ) {
          throw new Error(
            `No se pudo encolar el correo para ${fullName}`
          );
        }
      }
    },
    async confirmArchive() {
      if (!this.archiveObservation || !this.archiveObservation.trim()) {
        this.$fun.alert("La observación es obligatoria para archivar", "warning");
        return;
      }
      this.archivingRecruitment = true;
      try {
        await this.sendArchiveNotifications();

        await HmnRecruitmentProcessService.archive(
          { RprID: this.detail.RprID, Observation: this.archiveObservation.trim() },
          this.$fun.getUserID()
        );

        // Refrescar acciones del modal de inmediato (sin reabrir).
        if (this.detail) {
          this.detail = {
            ...this.detail,
            RprStatus: 0,
            RprStatusName: "ARCHIVADA",
          };
        }

        this.archiveDialog = false;
        this.$fun.alert("Convocatoria archivada correctamente", "success");
        await this.syncDetailStatusAfterChange(0, "ARCHIVADA");
        // Dar un momento para que la UI se estabilice antes de cargar candidatos
        await new Promise((resolve) => setTimeout(resolve, 100));
        await this.loadCandidates();
        this.detailDialog = false; // ✅ Cerrar modal
        this.detail = null; // ✅ Limpiar selección ANTES de refresh
        await this.$nextTick(); // ✅ Esperar a que Vue procese el cambio
        this.$refs.rprCrud.refresh(); // Ahora hacer refresh sin selección
        this.loadRequirements();
      } catch (error) {
        this.$fun.alert(
          error?.response?.data || error?.message || "No se pudo archivar la convocatoria",
          "warning"
        );
      } finally {
        this.archivingRecruitment = false;
      }
    },
    async reopenRecruitment() {
      const confirmed = await this.$fun.alert(
        "¿Está seguro de reabrir esta convocatoria?",
        "question"
      );
      if (!confirmed?.isConfirmed) return;
      this.reopeningRecruitment = true;
      try {
        await HmnRecruitmentProcessService.reopen(
          { RprID: this.detail.RprID, Observation: "Reapertura de convocatoria" },
          this.$fun.getUserID()
        );

        // Refrescar acciones del modal de inmediato (sin reabrir).
        if (this.detail) {
          this.detail = {
            ...this.detail,
            RprStatus: 1,
            RprStatusName: "ABIERTA",
          };
        }

        this.$fun.alert("Convocatoria reactivada correctamente", "success");
        await this.syncDetailStatusAfterChange(1, "ABIERTA");
        // Dar un momento para que la UI se estabilice antes de cargar candidatos
        await new Promise((resolve) => setTimeout(resolve, 100));
        await this.loadCandidates();
        this.detailDialog = false; // ✅ Cerrar modal
        this.detail = null; // ✅ Limpiar selección ANTES de refresh
        await this.$nextTick(); // ✅ Esperar a que Vue procese el cambio
        this.$refs.rprCrud.refresh(); // Ahora hacer refresh sin selección
        this.loadRequirements();
      } catch (error) {
        this.$fun.alert(
          error?.response?.data || "No se pudo reabrir la convocatoria",
          "warning"
        );
      } finally {
        this.reopeningRecruitment = false;
      }
    },
    async openHistoryDialog() {
      this.historyDialog = true;
      this.loadingHistory = true;
      try {
        const res = await HmnRecruitmentProcessService.history(
          this.detail.RprID,
          this.$fun.getUserID()
        );
        this.historyItems = res.data || [];
      } catch (_) {
        this.historyItems = [];
      } finally {
        this.loadingHistory = false;
      }
    },
    async syncDetailStatusAfterChange(expectedStatus, expectedStatusName) {
      if (!this.detail?.RprID) return;

      const maxAttempts = 5;
      for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
        try {
          const response = await HmnRecruitmentProcessService.byID(
            this.detail.RprID,
            this.$fun.getUserID()
          );

          if (response.status === 200) {
            const freshDetail = response.data || {};
            const freshStatus = Number(freshDetail.RprStatus);
            
            // ✅ Si el backend trae CERRADO (2) cuando esperamos ARCHIVADA (0), forzar ARCHIVADA
            if (expectedStatus === 0 && freshStatus === 2) {
              freshDetail.RprStatus = 0;
              freshDetail.RprStatusName = "ARCHIVADA";
            }
            
            if (freshStatus === Number(expectedStatus) || (expectedStatus === 0 && freshStatus === 2)) {
              // ✅ Backend refleja el cambio - reemplazar completamente el detail
              this.detail = freshDetail;
              if (Number(expectedStatus) === 1) {
                await this.ensureAllQuestionsAssignedToRecruitment();
              }
              return;
            }
          }
        } catch (_) {}

        await new Promise((resolve) => setTimeout(resolve, 350));
      }

      // ❌ Backend aún no refleja cambio - mantener estado optimista
      this.detail = {
        ...this.detail,
        RprStatus: Number(expectedStatus),
        RprStatusName: expectedStatusName,
      };
    },
    async openRecruitment(req) {
      if (!this.$fun.isAdmin()) {
        this.$fun.alert(
          "Solo los administradores pueden aperturar convocatorias",
          "warning"
        );
        return;
      }
      this.pendingReqToOpen = req;
      this.openingRecruiting = true;
      try {
        const paramRes = await _sGenParam.search(
          { PrmName: "QuestionsPreliminar_RRHH" },
          this.$fun.getUserID()
        );
        const defID = parseInt(paramRes.data?.PrmValue);
        if (!defID)
          throw new Error("No se encontró la definición de preguntas");
        const questionsRes = await DefinitionService.definitiongroup(
          defID,
          0,
          this.$fun.getUserID()
        );
        const allQuestionIDs = (questionsRes.data || []).map((q) => q.DedValue);
        if (!allQuestionIDs.length) {
          this.$fun.alert(
            "No hay preguntas configuradas para aperturar",
            "warning"
          );
          return;
        }
        await this.confirmRecruitmentOpening(allQuestionIDs);
      } catch (error) {
        this.$fun.alert(
          error?.response?.data || "No se pudo aperturar",
          "warning"
        );
        this.openingRecruiting = false;
        this.pendingReqToOpen = null;
      }
    },
    async confirmRecruitmentOpening(selectedQuestions) {
      this.openingRecruiting = true;
      try {
        const normalizedQuestions = Array.from(
          new Set(
            (Array.isArray(selectedQuestions) ? selectedQuestions : [])
              .map((id) => Number(id))
              .filter((id) => Number.isFinite(id) && id > 0)
          )
        );
        if (!normalizedQuestions.length) {
          this.$fun.alert("No hay preguntas válidas para aperturar", "warning");
          return;
        }

        const payload = {
          ReqID: this.pendingReqToOpen.ReqID,
          PstResponsibleID: null,
          TemplateJSON: JSON.stringify(normalizedQuestions),
        };
        await HmnRecruitmentProcessService.save(payload, this.$fun.getUserID());
        this.$fun.alert("Convocatoria aperturada", "success");
        this.$refs.rprCrud.refresh();
        this.loadRequirements();
        this.questionsDialog = false;
      } catch (error) {
        this.$fun.alert(
          error?.response?.data || "No se pudo aperturar",
          "warning"
        );
      } finally {
        this.openingRecruiting = false;
        this.pendingReqToOpen = null;
      }
    },
    onQuestionsCancel() {
      this.pendingReqToOpen = null;
      this.questionsDialog = false;
    },
    onQuestionsLoaded(questions) {
      // ✅ Guardar el cache de preguntas cuando se carguen
      this.cachedQuestions = questions;
    },
    normalizeQuestionIds(questionIds) {
      return Array.from(
        new Set(
          (Array.isArray(questionIds) ? questionIds : [])
            .map((id) => Number(id))
            .filter((id) => Number.isFinite(id) && id > 0)
        )
      );
    },
    parseTemplateQuestionIds(templateJSON) {
      if (!templateJSON) return [];
      try {
        let selectedQuestionIds = templateJSON;
        if (typeof selectedQuestionIds === "string") {
          selectedQuestionIds = JSON.parse(selectedQuestionIds);
        }
        if (typeof selectedQuestionIds === "string") {
          selectedQuestionIds = JSON.parse(selectedQuestionIds);
        }
        return this.normalizeQuestionIds(selectedQuestionIds);
      } catch (_) {
        return [];
      }
    },
    async fetchAllPreliminaryQuestionIds() {
      const paramRes = await _sGenParam.search(
        { PrmName: "QuestionsPreliminar_RRHH" },
        this.$fun.getUserID()
      );
      const defID = parseInt(paramRes.data?.PrmValue);
      if (!defID) return [];

      const questionsRes = await DefinitionService.definitiongroup(
        defID,
        0,
        this.$fun.getUserID()
      );
      return this.normalizeQuestionIds(
        (questionsRes.data || []).map((q) => q.DedValue)
      );
    },
    async ensureAllQuestionsAssignedToRecruitment() {
      const configuredIds = this.parseTemplateQuestionIds(this.detail?.TemplateJSON);
      if (configuredIds.length) return configuredIds;

      // Solo autocompletar en convocatorias abiertas.
      if (Number(this.detail?.RprStatus) !== 1) return [];

      try {
        const allQuestionIDs = await this.fetchAllPreliminaryQuestionIds();
        if (!allQuestionIDs.length) return [];

        const payload = {
          RprID: this.detail.RprID,
          PstResponsibleID: this.detail.PstResponsibleID || null,
          TemplateJSON: JSON.stringify(allQuestionIDs),
          RprStatus: Number(this.detail.RprStatus),
          RprCancelReason: this.detail.RprCancelReason || null,
        };

        await HmnRecruitmentProcessService.update(payload, this.$fun.getUserID());
        this.detail.TemplateJSON = payload.TemplateJSON;
        return allQuestionIDs;
      } catch (error) {
        console.error("Error in ensureAllQuestionsAssignedToRecruitment:", error);
        return [];
      }
    },
    onRecruitmentSelected(rows) {
      if (rows && rows.length) this.detail = rows[0];
    },
    async openDetail(item) {
      this.detailDialog = true;
      await this.loadDetail(item.RprID);
      await this.loadCandidates();
    },
    async loadDetail(rprID) {
      try {
        const response = await HmnRecruitmentProcessService.byID(
          rprID,
          this.$fun.getUserID()
        );
        if (response.status === 200 && response.data) {
          this.detail = response.data;
          // Fix de respaldo: si la convocatoria abierta no tiene preguntas, asignar todas.
          try {
            await this.ensureAllQuestionsAssignedToRecruitment();
          } catch (err) {
            console.error("Error al asignar preguntas de respaldo:", err);
          }
        } else {
          this.detail = null;
          this.$fun.alert(
            "No se pudieron obtener los detalles de la convocatoria o no tiene permisos.",
            "warning"
          );
        }
      } catch (error) {
        this.detail = null;
        console.error("Error loading detail:", error);
        this.$fun.alert("Error al cargar el detalle de la convocatoria.", "error");
      }
    },
    async loadCandidates() {
      if (!this.detail?.RprID) return;
      this.loadingCandidates = true;
      try {
        const [candidatesRes, waitingRes] = await Promise.all([
          HmnRecruitmentProcessService.getCandidates(
            this.detail.RprID,
            this.$fun.getUserID()
          ),
          HmnCandidateProcessService.getWaitingForBoss(
            this.detail.RprID,
            this.$fun.getUserID()
          ),
        ]);
        const promotionCandidates = Array.isArray(candidatesRes.data)
          ? candidatesRes.data.filter((candidate) => this.isPromotionCandidate(candidate))
          : [];

        if (candidatesRes.status === 200) this.candidates = promotionCandidates;
        
        // ✅ Usar $set para mantener reactividad sin romper el detail object
        const selectedCount = promotionCandidates.filter(
          (c) => Number(c.CprStatus) === 2
        ).length;
        this.$set(this.detail, 'TotalCandidates', promotionCandidates.length);
        this.$set(this.detail, 'SelectedCount', selectedCount);

        // Reconstruir sala de espera desde BD para sobrevivir recargas
        const newSala = {};
        if (waitingRes.status === 200) {
          (waitingRes.data || []).forEach((c) => {
            newSala[c.CprID] = true;
          });
        }
        this.candidatesReadyForBoss = newSala;
        // Limpiar selección si ya no están en sala
        this.selectedForBoss = this.selectedForBoss.filter(
          (c) => newSala[c.CprID]
        );
      } finally {
        this.loadingCandidates = false;
      }
    },
    closeCandidateDialog() {
      this.candidateDialog = false;
      this.isEditingCandidate = false;
      this.candidateFile = null;
      this.candidateAdmonition = null;
      this.showAdmonitionDetailDialog = false;
    },
    openCandidateDialog() {
      this.isEditingCandidate = false;
      this.candidateAdmonition = null;
      this.showAdmonitionDetailDialog = false;
      this.candidateForm = {
        CprID: 0,
        RprID: this.detail?.RprID || 0,
        PrsID: 0,
        PstID: this.detail?.ReqPstID || 0,
        CurrentStageID: 2,
        CprStatus: 1,
        SecStatus: 1,
        CprReadyForBoss: false,
        PpnID: 0,
        PemID: 0,
        SourceID: null,
        SourceDetail: "",
        FileKeyCV: null,
        Phone: "",
        TypePhone: 1,
        EmailUser: "",
        EmailDomain: 1,
        TypeDomainEmail: 1,
      };
      this.candidateFile = null;
      this.candidateDialog = true;
    },
    openEditCandidateDialog(item) {
      if (!item) return;

      this.candidateAdmonition = null;
      this.showAdmonitionDetailDialog = false;
      if (item.PrsDocumentNumber) {
        this.checkCandidateAdmonition(
          item.PrsDocumentNumber,
          item.NtpID || null,
          false
        );
      }

      const email = item.PemEmail || "";
      const atIndex = email.indexOf("@");
      const hasValue = (val) => val !== null && val !== undefined;

      this.isEditingCandidate = true;
      this.candidateForm = {
        CprID: item.CprID || 0,
        RprID: item.RprID || this.detail?.RprID || 0,
        PrsID: item.PrsID || 0,
        PstID: item.PstID || this.detail?.ReqPstID || 0,
        CurrentStageID: hasValue(item.CurrentStageID)
          ? Number(item.CurrentStageID)
          : 2,
        CprStatus: hasValue(item.CprStatus) ? Number(item.CprStatus) : 1,
        SecStatus: hasValue(item.SecStatus) ? Number(item.SecStatus) : 1,
        CprReadyForBoss: !!item.CprReadyForBoss,
        PpnID: item.PpnID || 0,
        PemID: item.PemID || 0,
        SourceID: item.SourceID || null,
        SourceDetail: item.SourceDetail || "",
        FileKeyCV: item.FileKeyCV || null,
        Phone: item.PpnNumberPhone || "",
        TypePhone: item.TypePhone || 1,
        EmailUser: atIndex > -1 ? email.substring(0, atIndex) : email,
        EmailDomain: item.TypeDomainEmail || 1,
        TypeDomainEmail: item.TypeDomainEmail || 1,
        FullName: item.FullName || item.CandidateName || "",
        PrsDocumentNumber: item.PrsDocumentNumber || "",
      };

      this.candidateFile = null;
      this.candidateDialog = true;
    },
    openBossApprovalModule() {
      // Navigate to the boss approval SCRUD module with RprID parameter
      this.$router.push({
        name: "HMN_BOSS_APPROVAL",
      });
    },
    async onPersonSelected(person) {
      if (!person) return;

      const lookupSeq = ++this.personLookupSeq;

      this.candidateForm.PrsID = person.PrsID;
      this.candidateForm.FullName = person.NtpFullName;
      this.candidateForm.PrsDocumentNumber = person.PrsDocumentNumber;

      // Resetear datos autocompletables para evitar arrastre del postulante anterior.
      this.candidateForm.Phone = "";
      this.candidateForm.TypePhone = 1;
      this.candidateForm.PpnID = 0;
      this.candidateForm.EmailUser = "";
      this.candidateForm.EmailDomain = 1;
      this.candidateForm.TypeDomainEmail = 1;
      this.candidateForm.PemID = 0;
      this.candidateForm.SourceID = null;
      this.candidateForm.SourceDetail = "";
      this.candidateForm.FileKeyCV = null;

      // Validar si el postulante tiene restricción laboral (Suspensión o Cese / Falta Grave)
      this.candidateAdmonition = null;
      this.checkCandidateAdmonition(
        person.PrsDocumentNumber,
        person.NtpID || person.GenNaturalPerson?.NtpID,
        true,
        lookupSeq
      );

      // Autocompletar con datos de la última convocatoria
      this.loadingPreviousData = true;
      try {
        const res = await HmnCandidateProcessService.getLastByPrsID(
          person.PrsID,
          this.$fun.getUserID()
        );
        // Ignorar respuesta tardía si el usuario ya seleccionó otro postulante.
        if (lookupSeq !== this.personLookupSeq) return;

        const prev = res?.data;
        if (prev) {
          if (prev.PpnNumberPhone)
            this.candidateForm.Phone = prev.PpnNumberPhone;
          if (prev.TypePhone) this.candidateForm.TypePhone = prev.TypePhone;
          if (prev.PpnID) this.candidateForm.PpnID = prev.PpnID;
          if (prev.EmailUser) this.candidateForm.EmailUser = prev.EmailUser;
          if (prev.TypeDomainEmail) {
            this.candidateForm.EmailDomain = prev.TypeDomainEmail;
            this.candidateForm.TypeDomainEmail = prev.TypeDomainEmail;
          }
          if (prev.PemID) this.candidateForm.PemID = prev.PemID;
          if (prev.SourceID) this.candidateForm.SourceID = prev.SourceID;
          if (prev.SourceDetail)
            this.candidateForm.SourceDetail = prev.SourceDetail;
          if (prev.FileKeyCV) this.candidateForm.FileKeyCV = prev.FileKeyCV;
        }
      } catch (_) {
        // Sin convocatoria previa — no es error
      } finally {
        this.loadingPreviousData = false;
      }
    },
    async checkCandidateAdmonition(
      documentNumber,
      ntpID = null,
      showAlert = true,
      lookupSeq = null
    ) {
      if (!documentNumber && !ntpID) return;
      this.checkingAdmonition = true;
      try {
        let resolvedNtpID = ntpID;
        if (!resolvedNtpID && documentNumber) {
          try {
            const npResp = await PersonService.getNaturalPerson(
              documentNumber,
              this.$fun.getUserID()
            );
            if (npResp?.status === 200 && npResp.data?.NtpID) {
              resolvedNtpID = npResp.data.NtpID;
            }
          } catch (_) {}
        }

        if (resolvedNtpID) {
          const respAdm = await _sAdmonition.adminitionByNtpID(
            resolvedNtpID,
            this.$fun.getUserID()
          );
          if (lookupSeq !== null && lookupSeq !== this.personLookupSeq) return;

          if (respAdm?.status === 200 && respAdm.data) {
            const adm = respAdm.data;
            // Solo alertar si es restricción severa: Suspensión (3) o Cese / Falta Grave (4)
            if (adm.TypeAdmonition === 3 || adm.TypeAdmonition === 4) {
              this.candidateAdmonition = adm;
              if (showAlert) {
                this.$fun.alert(
                  `¡ATENCIÓN! El postulante presenta RESTRICCIÓN LABORAL (${
                    adm.TypeAdmonitionName || "Falta Grave / Suspensión"
                  }).`,
                  "warning"
                );
              }
            }
          }
        }
      } catch (err) {
        console.error("Error al validar restricción del postulante:", err);
      } finally {
        this.checkingAdmonition = false;
      }
    },
    detectCandidateCVPreviewType(contentType, fallbackName) {
      const ct = (contentType || "").toLowerCase();
      if (ct.startsWith("image/")) return "image";
      if (ct.indexOf("pdf") !== -1) return "pdf";
      if (fallbackName) {
        const lower = fallbackName.toLowerCase();
        if (lower.endsWith(".pdf")) return "pdf";
        if (lower.match(/\.(jpg|jpeg|png|gif|webp|bmp)$/)) return "image";
      }
      return "other";
    },
    async openCandidateCVPreview(item) {
      const fileKey = item?.FileKeyCV;
      if (!fileKey) {
        this.$fun.alert("El candidato no tiene CV adjunto", "warning");
        return;
      }

      try {
        const file = await GenUploadFiles.getFileForPreview(
          "routeCVRecruitment_RRHH",
          fileKey
        );

        if (!file || !file.url) {
          this.$fun.alert("No se pudo cargar el CV", "error");
          return;
        }

        this.candidateCVPreviewUrl = file.url;
        this.candidateCVPreviewType = this.detectCandidateCVPreviewType(
          file.contentType,
          fileKey
        );
        this.candidateCVPreviewFileName = fileKey;
        this.candidateCVPreviewDialog = true;
      } catch (error) {
        this.$fun.alert("No se pudo previsualizar el CV", "error");
      }
    },
    downloadCandidateCV() {
      if (!this.candidateCVPreviewFileName) return;
      GenUploadFiles.getFile(
        "routeCVRecruitment_RRHH",
        this.candidateCVPreviewFileName
      );
    },
    closeCandidateCVPreview() {
      if (this.candidateCVPreviewUrl) {
        URL.revokeObjectURL(this.candidateCVPreviewUrl);
      }
      this.candidateCVPreviewDialog = false;
      this.candidateCVPreviewUrl = null;
      this.candidateCVPreviewType = null;
      this.candidateCVPreviewFileName = null;
    },
    async saveCandidate() {
      if (!this.candidateForm.PrsID) {
        this.$fun.alert("Selecciona una persona", "warning");
        return;
      }

      if (!this.candidateForm.Phone || this.candidateForm.Phone.length !== 9) {
        this.$fun.alert("Ingresa un teléfono válido (9 dígitos)", "warning");
        return;
      }

      if (!this.candidateForm.TypePhone) {
        this.$fun.alert("Selecciona un tipo de teléfono", "warning");
        return;
      }

      if (!this.candidateForm.EmailUser) {
        this.$fun.alert("Ingresa el usuario del correo", "warning");
        return;
      }

      if (!this.candidateForm.EmailDomain) {
        this.$fun.alert("Selecciona un dominio de correo", "warning");
        return;
      }

      this.savingCandidate = true;
      try {
        // 1. Subir CV si existe
        if (this.candidateFile) {
          const file = Array.isArray(this.candidateFile)
            ? this.candidateFile[0]
            : this.candidateFile;
          if (file) {
            const fileToUpload = await this.compressPdfForUpload(file);
            const fileName = `CV_${this.detail.ReqID}_${this.candidateForm.PrsDocumentNumber}`;
            const upload = await GenUploadFiles.upload(
              fileToUpload,
              fileName,
              "routeCVRecruitment_RRHH",
              true
            );
            if (upload.status === 200) {
              this.candidateForm.FileKeyCV = upload.data.fileName;
            }
          }
        }
        if (!this.isEditingCandidate) {
          this.candidateForm.CurrentStageID = 2;
          this.candidateForm.CprStatus = 1;
          this.candidateForm.SecStatus = 1;
          this.candidateForm.TypeSeeking = 2;
        }
        // 2. Guardar candidato
        await HmnCandidateProcessService.save(
          this.candidateForm,
          this.$fun.getUserID()
        );
        // 3. Guardar teléfono
        const phoneData = {
          PpnID: this.candidateForm.PpnID || 0,
          PrsID: this.candidateForm.PrsID,
          TypePhone: this.candidateForm.TypePhone,
          PpnNumberPhone: this.candidateForm.Phone,
          PpnIsDefault: 1,
          UsrCreateID: this.$fun.getUserID(),
        };
        await GenPersonTelephoneService.save(phoneData, this.$fun.getUserID());

        const emailData = {
          PemID: this.candidateForm.PemID || 0,
          PrsID: this.candidateForm.PrsID,
          PemEmail: this.candidateForm.EmailUser,
          PemIsDefault: 1,
          TypeDomainEmail: this.candidateForm.EmailDomain,
          UsrCreateID: this.$fun.getUserID(),
        };
        await GenPersonEmailService.save(emailData, this.$fun.getUserID());
      this.$fun.alert(
        this.isEditingCandidate
          ? "Candidato actualizado correctamente"
          : "Candidato registrado correctamente",
        "success"
      );
      this.closeCandidateDialog();
      //carga en false de boton
      this.savingCandidate = false;
      this.loadCandidates();
      } catch (error) {
        this.savingCandidate = false;
        console.error("Error guardando candidato:", error.message);
      }
      
    },
    async deleteCandidate(item) {
      if (!item?.CprID) return;

      const result = await this.$fun.alert(
        `¿Eliminar a ${item.FullName || "este candidato"}?`,
        "question"
      );
      if (!result?.isConfirmed) return;

      const hasValue = (val) => val !== null && val !== undefined;
      const payload = {
        CprID: item.CprID,
        RprID: item.RprID || this.detail?.RprID || 0,
        PrsID: item.PrsID || 0,
        PstID: item.PstID || this.detail?.ReqPstID || 0,
        CurrentStageID: hasValue(item.CurrentStageID)
          ? Number(item.CurrentStageID)
          : 2,
        CprStatus: hasValue(item.CprStatus) ? Number(item.CprStatus) : 1,
        CprReadyForBoss: !!item.CprReadyForBoss,
        SourceID: hasValue(item.SourceID) ? item.SourceID : null,
        FileKeyCV: item.FileKeyCV || null,
        SourceDetail: item.SourceDetail || "",
        SecStatus: 0,
      };

      try {
        await HmnCandidateProcessService.save(payload, this.$fun.getUserID());
        this.$fun.alert("Candidato eliminado correctamente", "success");
        await this.loadCandidates();
      } catch (error) {
        this.$fun.alert(
          error?.response?.data || "No se pudo eliminar al candidato",
          "error"
        );
      }
    },
    async retrocederCandidate(item) {
      const currentStage = Number(item.CurrentStageID);
      const prevStage = currentStage - 1;
      if (prevStage < 2) return;

      const result = await this.$fun.alert(
        `¿Retroceder a ${
          item.FullName || "este candidato"
        } a la etapa anterior?`,
        "question"
      );
      if (!result?.isConfirmed) return;

      await HmnCandidateProcessService.advanceStage(
        item.CprID,
        prevStage,
        "Retrocedido manualmente",
        this.$fun.getUserID()
      );
      this.loadCandidates();
    },
    async advanceCandidate(item) {
      const currentStage = Number(item.CurrentStageID);
      const nextStage = currentStage + 1;

      if (nextStage > 7) {
        this.$fun.alert("El candidato ya está en la última etapa", "info");
        return;
      }

      if (currentStage === 5 && nextStage === 6) {
        if (!this.isResponsibleBoss) {
          this.$fun.alert(
            "Solo el jefe del área responsable puede avanzar a entrevista de área",
            "warning"
          );
          return;
        }
      }

      // Si está avanzando de etapa 4 (Interview) a 5 (BossInterview)
      // Mostrar dialog para responder preguntas
      if (currentStage === 4 && nextStage === 5) {
        this.pendingAdvance = { candidate: item, nextStage };
        this.currentRprID = this.detail.RprID; // ✅ Guardar RprID para cargar preguntas

        // Cargar preguntas configuradas en el TemplateJSON de la convocatoria
        try {
          let selectedQuestionIds = this.parseTemplateQuestionIds(
            this.detail.TemplateJSON
          );
          if (!selectedQuestionIds.length) {
            selectedQuestionIds = await this.ensureAllQuestionsAssignedToRecruitment();
          }

          // Normalizar IDs (string/number) para que el formulario pueda cruzar correctamente.
          this.interviewQuestions = this.normalizeQuestionIds(selectedQuestionIds);

          if (!this.interviewQuestions.length) {
            this.$fun.alert(
              "La convocatoria no tiene preguntas válidas configuradas",
              "warning"
            );
            return;
          }

          this.answerQuestionsDialog = true;
        } catch (error) {
          console.error(
            "Error parsing TemplateJSON:",
            this.detail.TemplateJSON,
            error
          );
        }
      } else {
        // Avance directo sin preguntas
        await HmnCandidateProcessService.advanceStage(
          item.CprID,
          nextStage,
          "",
          this.$fun.getUserID()
        );
        this.loadCandidates();
      }
    },
    async confirmAdvanceWithAnswers(answers) {
      this.advancingCandidate = true;
      try {
        const { candidate } = this.pendingAdvance;
        const responsesJSON = Object.keys(answers).map((dedValue) => ({
          ColumnName: dedValue,
          Value: answers[dedValue] || "",
        }));
        // Guardar respuestas en BD
        await HmnCandidateProcessService.saveInterviewResponses(
          candidate.CprID,
          JSON.stringify(responsesJSON),
          this.$fun.getUserID()
        );
        // Persistir estado en BD (columna CprReadyForBoss = 1)
        await HmnCandidateProcessService.setReadyForBoss(
          candidate.CprID,
          true,
          this.$fun.getUserID()
        );
        this.$set(this.candidatesReadyForBoss, candidate.CprID, true);
        this.$fun.alert(
          "Respuestas guardadas — candidato en sala de espera",
          "success"
        );
        this.answerQuestionsDialog = false;
        this.pendingAdvance = null;
        this.loadCandidates();
      } catch (error) {
        // this.$fun.alert(error?.response?.data || "Error al guardar respuestas", "error");
      } finally {
        this.advancingCandidate = false;
      }
    },
    async sendSelectedToBoss() {
      const toSend = [...this.selectedForBoss];
      if (!toSend.length) {
        this.$fun.alert("Selecciona al menos un candidato", "warning");
        return;
      }
      const confirm = await this.$fun.alert(
        `¿Enviar ${toSend.length} candidato(s) al cliente interno?`,
        "question"
      );
      if (!confirm.isConfirmed) return;
      this.sendingToBoss = true;
      try {
        await Promise.all(
          toSend.map((c) =>
            HmnCandidateProcessService.advanceStage(
              c.CprID,
              5,
              "Enviado al cliente interno por RRHH",
              this.$fun.getUserID()
            )
          )
        );
        toSend.forEach((c) =>
          this.$delete(this.candidatesReadyForBoss, c.CprID)
        );
        this.selectedForBoss = [];
        this.$fun.alert(
          `${toSend.length} candidato(s) enviados al cliente interno`,
          "success"
        );
        this.loadCandidates();
      } catch (error) {
        this.$fun.alert(
          error?.response?.data || "Error al enviar candidatos",
          "error"
        );
      } finally {
        this.sendingToBoss = false;
      }
    },
    removeFromSala(item) {
      // Persistir en BD
      HmnCandidateProcessService.setReadyForBoss(
        item.CprID,
        false,
        this.$fun.getUserID()
      ).catch(() => {});
      this.$delete(this.candidatesReadyForBoss, item.CprID);
      const idx = this.selectedForBoss.findIndex((c) => c.CprID === item.CprID);
      if (idx > -1) this.selectedForBoss.splice(idx, 1);
    },
    onAnswersCancel() {
      this.answerQuestionsDialog = false;
      this.pendingAdvance = null;
    },
    isPromotionCandidate(item) {
      return Number(item?.TypeSeeking) === 2;
    },
    getPromotionChecklistLabel(item) {
      const summary = this.promotionChecklistSummary[item?.CprID];
      if (!summary) return "Sin revisar";
      return `${summary.completed}/${summary.total} checks`;
    },
    async ensurePromotionChecklistSummary(item) {
      const existing = this.promotionChecklistSummary[item?.CprID];
      if (existing) return existing;

      const response = await HmnCandidateProcessService.promotionChecklist(
        item.CprID,
        this.$fun.getUserID()
      );
      const rows = Array.isArray(response.data) ? response.data : [];
      const summary = {
        CprID: item.CprID,
        completed: rows.filter((row) => !!row.IsChecked).length,
        total: rows.length,
      };
      this.$set(this.promotionChecklistSummary, item.CprID, summary);
      return summary;
    },
    openPromotionChecklist(item) {
      if (!this.isPromotionCandidate(item)) return;
      this.promotionChecklistCandidate = item;
      this.promotionChecklistDialog = true;
    },
    onPromotionChecklistSummary(summary) {
      if (!summary?.CprID) return;
      this.$set(this.promotionChecklistSummary, summary.CprID, summary);
    },
    async selectCandidate(item) {
      if (!this.isPromotionCandidate(item)) return;
      const reqQty = Number(this.detail?.ReqQuantity || 0);
      const selected = Number(this.detail?.SelectedCount || 0);
      if (reqQty > 0 && selected >= reqQty) {
        this.$fun.alert(
          `Ya se alcanzó el límite de seleccionados (${selected}/${reqQty})`,
          "warning"
        );
        return;
      }
      const checklist = await this.ensurePromotionChecklistSummary(item);
      if (!checklist.completed) {
        this.$fun.alert(
          "La promoción requiere al menos un check completado antes de seleccionar",
          "warning"
        );
        return;
      }

      const result = await this.$fun.alert(
        `¿Seleccionar a ${item.FullName || "este candidato"} sin envío de correo?`,
        "question"
      );
      if (!result?.isConfirmed) return;

      await HmnCandidateProcessService.updateStatus(
        item.CprID,
        2,
        "Seleccionado manualmente en promoción",
        this.$fun.getUserID()
      );
      this.$fun.alert("Candidato seleccionado", "success");
      await this.loadCandidates();
      if (this.detail?.RprID) {
        await this.loadDetail(this.detail.RprID);
      }
    },
    resendCandidateNotification(item) {
      if (item.CprStatus == 2) {
        this.openWelcomeDialog(item, true);
      } else if (item.CprStatus == 0) {
        this.openRejectionDialog(item);
      } else {
        this.$fun.alert(
          "Solo se pueden reenviar notificaciones a candidatos seleccionados",
          "warning"
        );
      }
    },
    openWelcomeDialog(item, isResend) {
      this.selectedCandidate = item;
      this.welcomeIsResend = isResend;
      this.welcomeStartDate = item?.CprStartDate
        ? new Date(item.CprStartDate).toISOString().slice(0, 10)
        : new Date().toISOString().slice(0, 10);
      this.welcomeAdditionalFiles = [];
      this.welcomePreviewReady = false;
      this.welcomeAssetsLoaded = false;
      this.welcomePreviewImageDataUrl = "";
      this.welcomePreviewImageBytes = "";
      this.welcomeDialog = true;
    },
    closeWelcomeDialog() {
      this.welcomeDialog = false;
      this.welcomePreviewReady = false;
      this.selectedCandidate = null;
      this.welcomeMailData = null;
      this.welcomePreviewImageDataUrl = "";
      this.welcomePreviewImageBytes = "";
    },
    async generateWelcomePreview() {
      if (!this.welcomeStartDate) {
        this.$fun.alert("Ingrese la fecha de inicio", "warning");
        return;
      }

      this.generatingPreview = true;
      try {
        const preparePayload = {
          CprID: this.selectedCandidate.CprID,
          CprStartDate: this.welcomeStartDate,
          Observation: "",
        };

        const preparedResponse =
          await HmnCandidateProcessService.prepareWelcomeEmail(
            preparePayload,
            this.$fun.getUserID()
          );

        this.welcomeMailData = preparedResponse.data;
        await this.ensureWelcomeAssetsLoaded(true);
        this.renderWelcomeTemplate();

        await this.$nextTick();
        const previewImageBytes = await this.buildWelcomeImageBytes();
        this.welcomePreviewImageBytes = previewImageBytes;
        this.welcomePreviewImageDataUrl = `data:image/png;base64,${previewImageBytes}`;
        this.welcomePreviewReady = true;
      } catch (error) {
        this.$fun.alert(
          error?.response?.data || "Error al generar previsualización",
          "error"
        );
      } finally {
        this.generatingPreview = false;
      }
    },
    async blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const result = typeof reader.result === "string" ? reader.result : "";
          const base64 = result.includes(",") ? result.split(",")[1] : result;
          resolve(base64 || "");
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },
    normalizeAttachmentBytes(value) {
      if (!value) return null;
      if (typeof value === "string") return value;

      if (Array.isArray(value)) {
        let binary = "";
        const chunkSize = 0x8000;
        for (let index = 0; index < value.length; index += chunkSize) {
          const chunk = value.slice(index, index + chunkSize);
          binary += String.fromCharCode(...chunk);
        }
        return btoa(binary);
      }

      return null;
    },
    async compressPdfForUpload(file) {
      if (!(file instanceof File) || file.type !== "application/pdf") {
        return file;
      }

      try {
        const originalBytes = await file.arrayBuffer();
        const sourcePdf = await pdfjsLib.getDocument({ data: originalBytes }).promise;
        const compressedPdf = await PDFDocument.create();

        for (let pageNumber = 1; pageNumber <= sourcePdf.numPages; pageNumber += 1) {
          const page = await sourcePdf.getPage(pageNumber);
          const viewport = page.getViewport({ scale: 1.2 });
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d", { alpha: false });

          if (!context) {
            throw new Error("No se pudo inicializar el canvas para comprimir el PDF");
          }

          canvas.width = Math.max(1, Math.floor(viewport.width));
          canvas.height = Math.max(1, Math.floor(viewport.height));

          await page.render({
            canvasContext: context,
            viewport,
          }).promise;

          const imageDataUrl = canvas.toDataURL("image/jpeg", 0.7);
          const embeddedImage = await compressedPdf.embedJpg(imageDataUrl);
          const pdfPage = compressedPdf.addPage([viewport.width, viewport.height]);

          pdfPage.drawImage(embeddedImage, {
            x: 0,
            y: 0,
            width: viewport.width,
            height: viewport.height,
          });
        }

        const compressedBytes = await compressedPdf.save({ useObjectStreams: true });

        if (compressedBytes.length >= originalBytes.byteLength) {
          return file;
        }

        return new File([compressedBytes], file.name, {
          type: "application/pdf",
          lastModified: file.lastModified,
        });
      } catch (error) {
        console.warn("No se pudo comprimir el PDF, se subirá el archivo original", error);
        return file;
      }
    },
    async buildWelcomeImageBytes() {
      await this.$nextTick();
      if (document.fonts?.ready) {
        await Promise.race([
          document.fonts.ready,
          new Promise((resolve) => setTimeout(resolve, 1200)),
        ]);
      }
      const template = this.$refs.welcomeTemplate;
      const canvas = await html2canvas(template, {
        allowTaint: true,
        useCORS: true,
        backgroundColor: "#ffffff",
      });
      const blob = await new Promise((resolve) =>
        canvas.toBlob(resolve, "image/png")
      );
      if (!blob) throw new Error("No se pudo generar la imagen de bienvenida");
      return this.blobToBase64(blob);
    },
    async ensureWelcomeAssetsLoaded(forceReload = false) {
      if (this.welcomeAssetsLoaded && !forceReload) return;

      const response = await HmnCandidateProcessService.welcomeAssets(
        this.$fun.getUserID()
      );
      this.welcomeTemplateHtmlRaw = response.data?.TemplateHtml || "";
      this.welcomePdfAttachments = Array.isArray(response.data?.Files)
        ? response.data.Files
        : [];
      this.welcomeBackgroundImageDataUrl =
        response.data?.BackgroundImageDataUrl || "";

      this.welcomeAssetsLoaded = true;
    },
    renderWelcomeTemplate() {
      const fullName = this.welcomeMailData?.FullName || "";
      const positionName = this.welcomeMailData?.PositionName || "";
      const startDate = this.welcomeMailData?.StartDateText || "";

      let html = this.welcomeTemplateHtmlRaw || "";

      // Reemplazar placeholders de datos
      html = html.replace(/\{\{\s*fullName\s*\}\}/g, fullName);
      html = html.replace(/\{\{\s*positionName\s*\}\}/g, positionName);
      html = html.replace(/\{\{\s*startDate\s*\}\}/g, startDate);

      // Reemplazar el background en el CSS
      html = html.replace(/\{\{\s*backgroundImageUrl\s*\}\}/g, "");

      // Aislar estilos del template para que no afecten el layout global (footer/sidebar/header)
      let scopedStyle = "";
      const styleMatches = [
        ...html.matchAll(/<style[^>]*>([\s\S]*?)<\/style>/gi),
      ];
      if (styleMatches.length) {
        const rawCss = styleMatches.map((m) => m[1] || "").join("\n");
        const prefixedCss = rawCss.replace(
          /(^|})\s*([^@{}][^{]+)\{/g,
          (full, brace, selectors) => {
            const scopedSelectors = selectors
              .split(",")
              .map((selector) => {
                const s = selector.trim();
                if (!s) return s;
                if (s.startsWith(".welcome-template-render")) return s;
                if (s === "body" || s === "html")
                  return ".welcome-template-render";
                return `.welcome-template-render ${s}`;
              })
              .join(", ");
            return `${brace} ${scopedSelectors} {`;
          }
        );

        scopedStyle = `<style>${prefixedCss}</style>`;
      }

      html = html.replace(/<head[\s\S]*?<\/head>/gi, "");
      html = html.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "");
      html = html.replace(/<!DOCTYPE[^>]*>/gi, "");
      html = html.replace(/<html[^>]*>/gi, "");
      html = html.replace(/<\/html>/gi, "");
      html = html.replace(/<body[^>]*>/gi, "");
      html = html.replace(/<\/body>/gi, "");

      if (scopedStyle) {
        html = `${scopedStyle}${html}`;
      }

      // Inyectar logo dentro del background
      if (this.welcomeBackgroundImageDataUrl) {
        const logoHtml = `<img src="${this.welcomeLogoUrl}" alt="Sunshine" style="max-width:220px;" crossorigin="anonymous" />`;
        const bgStyle = `background-image:url('${this.welcomeBackgroundImageDataUrl}');width:${EMAIL_TEMPLATE_WIDTH}px;background-size:cover;background-position:center bottom;background-repeat:no-repeat;`;
        html = html.replace(
          /<div\s+class=["']container["']\s*>/i,
          `<div class="container" style="${bgStyle}"><div style="text-align:center;padding:20px;">${logoHtml}</div>`
        );
      } else {
        const logoHtml = `<div style="text-align:center"><img src="${this.welcomeLogoUrl}" alt="Sunshine" style="max-width:220px;" crossorigin="anonymous" /></div>`;
        if (html.includes("<body>")) {
          html = html.replace("<body>", `<body>${logoHtml}`);
        } else {
          html = `${logoHtml}${html}`;
        }
      }

      this.welcomeTemplateHtml = html;
    },
    async fileToAttachment(file) {
      return {
        attachmentBytes: await this.blobToBase64(file),
        nameFile: file.name,
      };
    },
    async confirmCandidateSelection() {
      if (!this.welcomeMailData?.EmailTo) {
        this.$fun.alert("El candidato no tiene correo para envío", "warning");
        return;
      }

      this.sendingWelcomeEmail = true;
      try {
        const welcomeImageBytes =
          this.welcomePreviewImageBytes ||
          (await this.buildWelcomeImageBytes());
        const safeName = (this.welcomeMailData.FullName || "Candidato").replace(
          /\s+/g,
          "_"
        );

        const attachments = [
          {
            attachmentBytes: welcomeImageBytes,
            nameFile: `Bienvenida_${safeName}.png`,
            contentId: "AttachmentFile",
          },
        ];

        const additionalFiles = Array.isArray(this.welcomeAdditionalFiles)
          ? this.welcomeAdditionalFiles
          : this.welcomeAdditionalFiles
          ? [this.welcomeAdditionalFiles]
          : [];

        for (const file of additionalFiles) {
          if (!file) continue;
          attachments.push(await this.fileToAttachment(file));
        }

        const mailPayload = {
          emailTo: this.selectedCandidate.PemEmail,
          subject:
            this.welcomeMailData.Subject || "Bienvenido(a) a Sunshine",
          bodyMail: `
            <p><img src="cid:AttachmentFile" style="width: ${EMAIL_TEMPLATE_WIDTH}px; max-width: 100%;" /></p>
          `,
          emailCC: ["jcruzado@sunshineperu.com"],
          emailBCC: ["Lvalqui@sunshineperu.com", "Vhuaman@sunshineperu.com"],
          useRecruitmentParamConfig: true,
          includeDefaultTemplateAttachments: true,
          attachments,
        };

        const enqueueResponse = await GenEmailService.sendEmailWithAttach(
          mailPayload,
          this.$fun.getUserID()
        );

        if (
          enqueueResponse?.status !== 200 ||
          enqueueResponse?.data?.queued !== true
        ) {
          throw new Error("No se pudo encolar el correo en Hangfire");
        }

        await HmnCandidateProcessService.setNotificationSent(
          { CprID: this.selectedCandidate.CprID, CprSendNotification: true },
          this.$fun.getUserID()
        );
        if (!this.welcomeIsResend) {
          await HmnCandidateProcessService.updateStatus(
            this.selectedCandidate.CprID,
            2,
            "",
            this.$fun.getUserID()
          );
        }

        this.$fun.alert(
          this.welcomeIsResend
            ? "Notificación reenviada"
            : "Candidato seleccionado y correo enviado",
          "success"
        );
        this.welcomeDialog = false;
        this.selectedCandidate = null;
        this.welcomeMailData = null;
        this.welcomeAdditionalFiles = [];
        this.welcomeIsResend = false;
        // Recargar detalle para reflejar posible auto-cierre de convocatoria
        this.loadCandidates();
        if (this.detail?.RprID) {
          await this.loadDetail(this.detail.RprID);
          this.$refs.rprCrud.refresh();
        }
      } catch (error) {
        this.$fun.alert(
          error?.response?.data || "Error al enviar correo de bienvenida",
          "error"
        );
      } finally {
        this.sendingWelcomeEmail = false;
      }
    },
    async rejectCandidate(item) {
      if (!this.isPromotionCandidate(item)) return;
      const result = await this.$fun.alert(
        `¿Rechazar a ${item.FullName || "este candidato"} sin envío de correo?`,
        "question"
      );
      if (!result?.isConfirmed) return;

      await HmnCandidateProcessService.updateStatus(
        item.CprID,
        0,
        "Rechazado manualmente en promoción",
        this.$fun.getUserID()
      );
      this.$fun.alert("Candidato rechazado", "success");
      this.loadCandidates();
    },
    openRejectionDialog(item) {
      this.selectedCandidate = item;
      this.rejectionPreviewReady = false;
      this.rejectionAssetsLoaded = false;
      this.rejectionPreviewImageDataUrl = "";
      this.rejectionPreviewImageBytes = "";
      this.rejectionDialog = true;
    },
    closeRejectionDialog() {
      this.rejectionDialog = false;
      this.rejectionPreviewReady = false;
      this.selectedCandidate = null;
      this.rejectionPreviewImageDataUrl = "";
      this.rejectionPreviewImageBytes = "";
    },
    async generateRejectionPreview() {
      if (!this.selectedCandidate?.CprID) {
        this.$fun.alert("No hay candidato seleccionado", "warning");
        return;
      }

      this.generatingRejectionPreview = true;
      try {
        const prepareResponse =
          await HmnCandidateProcessService.prepareRejectionEmail(
            { CprID: this.selectedCandidate.CprID },
            this.$fun.getUserID()
          );

        if (prepareResponse.status !== 200) {
          throw new Error("No se pudo preparar los datos de rechazo");
        }

        this.rejectionMailData = prepareResponse.data;
        await this.ensureRejectionAssetsLoaded(true);
        this.renderRejectionTemplate();
        await this.$nextTick();

        const rejectionImageBytes = await this.buildRejectionImageBytes();
        this.rejectionPreviewImageBytes = rejectionImageBytes;
        this.rejectionPreviewImageDataUrl = `data:image/png;base64,${rejectionImageBytes}`;
        this.rejectionPreviewReady = true;
      } catch (error) {
        this.$fun.alert(
          error?.response?.data || "Error al generar preview de rechazo",
          "error"
        );
      } finally {
        this.generatingRejectionPreview = false;
      }
    },
    async ensureRejectionAssetsLoaded(forceReload = false) {
      if (this.rejectionAssetsLoaded && !forceReload) return;
      try {
        const response = await HmnCandidateProcessService.getRejectionAssets(
          this.$fun.getUserID()
        );

        if (response.status === 200) {
          this.rejectionTemplateHtmlRaw = response.data.TemplateHtml;
          this.rejectionBackgroundImageDataUrl =
            response.data.BackgroundImageDataUrl;
        }
      } finally {
        this.rejectionAssetsLoaded = true;
      }
    },
    renderRejectionTemplate() {
      let html = this.rejectionTemplateHtmlRaw || "";

      // Replace placeholders
      html = html.replace(
        /\{\{\s*candidateName\s*\}\}/gi,
        this.rejectionMailData?.FullName || ""
      );
      html = html.replace(
        /\{\{\s*fullName\s*\}\}/gi,
        this.rejectionMailData?.FullName || ""
      );
      html = html.replace(
        /\{\{\s*positionName\s*\}\}/gi,
        this.rejectionMailData?.PositionName || ""
      );
      html = html.replace(/\{\{\s*logoUrl\s*\}\}/gi, this.rejectionLogoUrl);
      // Apply background as inline style to ensure same behavior as welcome template.
      html = html.replace(/\{\{\s*backgroundImageUrl\s*\}\}/gi, "");

      // Extract and scope styles
      let scopedStyle = "";
      const styleMatches = [
        ...html.matchAll(/<style[^>]*>([\s\S]*?)<\/style>/gi),
      ];
      if (styleMatches.length) {
        const rawCss = styleMatches.map((m) => m[1] || "").join("\n");
        const prefixedCss = rawCss.replace(
          /(^|})\s*([^@{}][^{]+)\{/g,
          (full, brace, selectors) => {
            const scopedSelectors = selectors
              .split(",")
              .map((selector) => {
                const s = selector.trim();
                if (!s) return s;
                if (s.startsWith(".rejection-template-render")) return s;
                if (s === "body" || s === "html" || s === ":root")
                  return ".rejection-template-render";
                return `.rejection-template-render ${s}`;
              })
              .join(", ");
            return `${brace} ${scopedSelectors} {`;
          }
        );

        scopedStyle = `<style>${prefixedCss}</style>`;
      }

      html = html.replace(/<head[^>]*>[\s\S]*?<\/head>/gi, "");
      html = html.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "");
      html = html.replace(/<!DOCTYPE[^>]*>/gi, "");
      html = html.replace(/<html[^>]*>/gi, "");
      html = html.replace(/<\/html>/gi, "");
      html = html.replace(/<body[^>]*>/gi, "");
      html = html.replace(/<\/body>/gi, "");

      if (scopedStyle) {
        html = `${scopedStyle}${html}`;
      }

      if (this.rejectionBackgroundImageDataUrl) {
        const bgStyle = `background-image:url('${this.rejectionBackgroundImageDataUrl}');width:${EMAIL_TEMPLATE_WIDTH}px;background-size:cover;background-position:center bottom;background-repeat:no-repeat;`;
        html = html.replace(
          /<div\s+class=["']container["']\s*>/i,
          `<div class="container" style="${bgStyle}">`
        );
      }

      this.rejectionTemplateHtml = html;
    },
    async buildRejectionImageBytes() {
      const element = document.querySelector(".rejection-template-render");
      if (!element) {
        throw new Error("Elemento rejection-template-render no encontrado");
      }

      if (document.fonts?.ready) {
        await Promise.race([
          document.fonts.ready,
          new Promise((resolve) => setTimeout(resolve, 1200)),
        ]);
      }

      const blob = await html2canvas(element, {
        allowTaint: true,
        useCORS: true,
        backgroundColor: "#ffffff",
      }).then((canvas) => {
        return new Promise((resolve) => {
          canvas.toBlob(resolve);
        });
      });

      return this.blobToBase64(blob);
    },
    async confirmRejectionSelection() {
      if (!this.rejectionMailData?.EmailTo) {
        this.$fun.alert("El candidato no tiene correo para envío", "warning");
        return;
      }

      this.sendingRejectionEmail = true;
      try {
        const rejectionImageBytes =
          this.rejectionPreviewImageBytes ||
          (await this.buildRejectionImageBytes());
        const safeName = (
          this.rejectionMailData.FullName || "Candidato"
        ).replace(/\s+/g, "_");

        const attachments = [
          {
            attachmentBytes: rejectionImageBytes,
            nameFile: `Resultado_${safeName}.png`,
            contentId: "AttachmentFile",
          },
        ];

        const mailPayload = {
          emailTo: this.selectedCandidate.PemEmail,
          subject:
            this.rejectionMailData.Subject ||
            "Resultado de tu participación",
          bodyMail: `
            <p><img src="cid:AttachmentFile" style="width: ${EMAIL_TEMPLATE_WIDTH}px; max-width: 100%;" /></p>
          `,
          useRecruitmentParamConfig: true,
          includeDefaultTemplateAttachments: false,
          attachments,
        };

        const enqueueResponse = await GenEmailService.sendEmailWithAttach(
          mailPayload,
          this.$fun.getUserID()
        );

        if (
          enqueueResponse?.status !== 200 ||
          enqueueResponse?.data?.queued !== true
        ) {
          throw new Error("No se pudo encolar el correo en Hangfire");
        }

        await HmnCandidateProcessService.updateStatus(
          this.selectedCandidate.CprID,
          0,
          "",
          this.$fun.getUserID()
        );
        await HmnCandidateProcessService.setNotificationSent(
          { CprID: this.selectedCandidate.CprID, CprSendNotification: true },
          this.$fun.getUserID()
        );
        this.$fun.alert("Candidato rechazado y correo enviado", "success");
        this.rejectionDialog = false;
        this.selectedCandidate = null;
        this.rejectionMailData = null;
        this.loadCandidates();
      } catch (error) {
        this.$fun.alert(
          error?.response?.data || "Error al enviar correo de rechazo",
          "error"
        );
      } finally {
        this.sendingRejectionEmail = false;
      }
    },
    async viewInterviewResponses(item) {
      this.responsesDialog = true;
      this.loadingResponses = true;
      try {
        if (
          Array.isArray(this.cachedQuestions) &&
          this.cachedQuestions.length > 0
        ) {
          this.questionsMap = {};
          this.cachedQuestions.forEach((q) => {
            this.questionsMap[q.DedValue] = q.DedDescription;
          });
        }

        // ✅ Cargar respuestas del candidato
        const responsesResponse =
          await HmnCandidateProcessService.getInterviewResponses(
            item.CprID,
            this.$fun.getUserID()
          );
        if (responsesResponse.status === 200) {
          this.interviewResponses = responsesResponse.data;
        }
      } catch (error) {
        this.$fun.alert("Error al cargar respuestas", "error");
        console.error("Error:", error);
      } finally {
        this.loadingResponses = false;
      }
    },
    getQuestionText(dedValue) {
      // ✅ Obtener del mapeo cargado desde el servidor
      return this.questionsMap[dedValue] || `Pregunta ${dedValue}`;
    },
    async bossApprove(item) {
      // ✅ Validación: Solo el jefe responsable puede aprobar en etapa 5
      if (!this.isResponsibleBoss) {
        this.$fun.alert(
          "Solo el jefe del área puede aprobar candidatos",
          "error"
        );
        return;
      }

      // Aprobar: Avanzar a etapa 6 (PsychoEval), CprStatus se mantiene en 1
      try {
        await HmnCandidateProcessService.advanceStage(
          item.CprID,
          6, // PsychoEval
          "Aprobado por jefe de área",
          this.$fun.getUserID()
        );
        this.$fun.alert(
          "Candidato aprobado y avanzado a Evaluación Psicológica",
          "success"
        );
        this.loadCandidates();
      } catch (error) {
        this.$fun.alert(
          error?.response?.data || "Error al aprobar candidato",
          "error"
        );
      }
    },
    async bossReject(item) {
      // ✅ Validación: Solo el jefe responsable puede rechazar en etapa 5
      if (!this.isResponsibleBoss) {
        this.$fun.alert(
          "Solo el jefe del área puede rechazar candidatos",
          "error"
        );
        return;
      }

      // Rechazar: CprStatus = 0, se mantiene en etapa 5
      try {
        await HmnCandidateProcessService.updateStatus(
          item.CprID,
          0,
          "Rechazado por jefe de área",
          this.$fun.getUserID()
        );
        this.$fun.alert("Candidato rechazado", "success");
        this.loadCandidates();
      } catch (error) {
        this.$fun.alert(
          error?.response?.data || "Error al rechazar candidato",
          "error"
        );
      }
    },
    async bossReturn(item) {
      // ✅ Validación: Solo el jefe responsable puede devolver en etapa 5
      if (!this.isResponsibleBoss) {
        this.$fun.alert(
          "Solo el jefe del área puede devolver candidatos",
          "error"
        );
        return;
      }

      // Devolver: CprStatus = 1, retrocede a etapa 4 (Interview)
      try {
        await HmnCandidateProcessService.advanceStage(
          item.CprID,
          4, // Interview
          "Devuelto por jefe de área para re-evaluación",
          this.$fun.getUserID()
        );
        this.$fun.alert(
          "Candidato devuelto a Entrevista Preliminar",
          "success"
        );
        this.loadCandidates();
      } catch (error) {
        this.$fun.alert(
          error?.response?.data || "Error al devolver candidato",
          "error"
        );
      }
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Fraunces:wght@600&family=Manrope:wght@400;600;700&display=swap");

.rpr-page {
  --ink: #1e293b;
  --muted: #64748b;
  --accent: #b45309;
  --accent-soft: #fff7ed;
  --surface: #ffffff;
  --surface-soft: #f8fafc;
  --border: #e2e8f0;
  --shadow-soft: 0 8px 28px rgba(15, 23, 42, 0.07);
  --shadow-card: 0 12px 32px rgba(15, 23, 42, 0.08);
  background: radial-gradient(
      1100px 500px at 0% -10%,
      #ffedd5 0%,
      rgba(255, 237, 213, 0) 60%
    ),
    radial-gradient(
      900px 420px at 100% -5%,
      #dbeafe 0%,
      rgba(219, 234, 254, 0) 58%
    ),
    linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  min-height: calc(100vh - 75px);
  padding: 28px;
  padding-bottom: 56px;
  font-family: "Manrope", sans-serif;
  color: var(--ink);
  box-sizing: border-box;
}

.rpr-hero {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
  background: linear-gradient(125deg, #0f172a 0%, #1e293b 55%, #334155 100%);
  color: #f8fafc;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  box-shadow: var(--shadow-soft);
  padding: 24px 28px;
  margin-bottom: 24px;
}

.rpr-hero__kicker {
  text-transform: uppercase;
  letter-spacing: 0.14em;
  font-size: 0.7rem;
  font-weight: 700;
  color: rgba(248, 250, 252, 0.75);
}

.rpr-hero__title {
  font-family: "Fraunces", serif;
  font-size: clamp(1.5rem, 2.4vw, 2rem);
  line-height: 1.15;
  margin: 8px 0 6px;
}

.rpr-hero__subtitle {
  margin: 0;
  max-width: 560px;
  color: rgba(248, 250, 252, 0.82);
}

.rpr-hero__badge {
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.24);
  backdrop-filter: blur(2px);
  padding: 10px 16px;
  border-radius: 999px;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.rpr-container {
  max-width: 100% !important;
  padding-left: 0;
  padding-right: 0;
}

.rpr-detail-dialog {
  width: calc(100vw - 36px);
  max-width: 1800px;
  margin: 18px auto;
}

.rpr-card {
  border-radius: 18px;
  border: 1px solid var(--border);
  background: var(--surface);
  box-shadow: var(--shadow-soft);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.rpr-card:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-card);
}

.rpr-card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 18px 20px 10px;
}

.rpr-card__title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
}

.rpr-card__hint {
  color: var(--muted);
  font-size: 0.8rem;
}

.rpr-search {
  max-width: 260px;
}

.rpr-table {
  padding: 2px 14px 16px;
}

.rpr-action {
  text-transform: none;
}

.rpr-detail {
  border-radius: 20px;
  border: 1px solid var(--border);
  box-shadow: var(--shadow-card);
  max-height: calc(100vh - 36px);
  display: flex;
  flex-direction: column;
}

.rpr-detail__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  padding: 18px 22px 12px;
  border-bottom: 1px solid var(--border);
}

.rpr-detail__header h3 {
  margin: 0;
  font-weight: 700;
}

.rpr-detail__header p {
  margin: 4px 0 0;
  color: var(--muted);
}

.rpr-detail__body {
  padding-top: 14px;
  overflow: auto;
}

.rpr-meta {
  display: grid;
  gap: 10px;
  background: linear-gradient(180deg, var(--accent-soft) 0%, #fffaf5 100%);
  border: 1px solid #fed7aa;
  border-radius: 16px;
  padding: 16px;
  font-size: 0.9rem;
}

.rpr-meta span {
  color: var(--muted);
  display: block;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.09em;
}

.rpr-meta strong {
  font-size: 1.02rem;
  color: #0f172a;
}

.rpr-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 14px;
}

.rpr-table__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.rpr-table__actions .v-btn,
.rpr-actions .v-btn,
.rpr-action {
  border-radius: 10px;
  font-weight: 700;
  letter-spacing: 0.01em;
  text-transform: none;
}

.rpr-actions .v-btn:not(.v-btn--text),
.rpr-action.v-btn:not(.v-btn--text) {
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.12);
}

.rpr-table .v-chip {
  border-radius: 999px;
  font-weight: 700;
}

.rpr-candidate {
  border-radius: 18px;
  border: 1px solid var(--border);
  box-shadow: var(--shadow-soft);
}

.welcome-template-wrapper {
  position: fixed;
  top: -10000px;
  left: -10000px;
  width: var(--email-tmpl-w);
  background: #ffffff;
}

.welcome-template-render {
  width: var(--email-tmpl-w);
  min-height: 630px;
  box-sizing: border-box;
  background: #ffffff;
}
.welcome-preview-container {
  margin-bottom: 16px;
}

.welcome-preview-box {
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 16px;
  background: var(--surface-soft);
  overflow: auto;
  max-height: 500px;
}

.welcome-template-preview {
  width: var(--email-tmpl-w);
  margin: 0 auto;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.14);
}

.welcome-preview-image {
  width: var(--email-tmpl-w);
  max-width: 100%;
  display: block;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.14);
}

.rejection-template-wrapper {
  position: fixed;
  top: -10000px;
  left: -10000px;
  width: var(--email-tmpl-w);
  background: #ffffff;
}

.rejection-template-render {
  width: var(--email-tmpl-w);
  min-height: 630px;
  box-sizing: border-box;
  background: #ffffff;
}

.rejection-template-preview {
  width: var(--email-tmpl-w);
  margin: 0 auto;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.14);
}

.archive-template-wrapper {
  position: fixed;
  top: -10000px;
  left: -10000px;
  width: 800px;
  background: transparent;
}

.archive-template-render {
  width: 800px;
  min-height: 800px;
  box-sizing: border-box;
  background: transparent;
}

@media (max-width: 960px) {
  .rpr-page {
    padding: 16px;
    padding-bottom: 34px;
  }

  .rpr-hero {
    flex-direction: column;
    align-items: flex-start;
    padding: 18px;
  }

  .rpr-hero__badge {
    align-self: flex-start;
  }

  .rpr-card__header {
    flex-direction: column;
    align-items: flex-start;
  }

  .rpr-search {
    width: 100%;
    max-width: 100%;
  }

  .rpr-actions {
    justify-content: flex-start;
  }

  .rpr-detail-dialog {
    width: calc(100vw - 12px);
    margin: 6px auto;
  }

  .rpr-detail {
    max-height: calc(100vh - 12px);
  }
}

/* ── Toolbar del detalle ── */
.rpr-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.rpr-toolbar__sec {
  display: flex;
  align-items: center;
  gap: 2px;
}

/* ── Menú dropdown acciones ── */
.rpr-menu-item {
  font-size: 13px !important;
}

/* ── Sala de espera ── */
.rpr-sala {
  border: 1px solid #fcd34d;
  border-radius: 14px;
  overflow: hidden;
  background: #fffbeb;
}
.rpr-sala__header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  background: linear-gradient(135deg, #fef3c7 0%, #fffbeb 100%);
  border-bottom: 1px solid #fde68a;
}
.rpr-sala__icon-wrap {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(245, 158, 11, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.rpr-sala__info {
  display: flex;
  flex-direction: column;
}
.rpr-sala__title {
  font-weight: 700;
  font-size: 0.875rem;
  color: #92400e;
}
.rpr-sala__sub {
  font-size: 0.75rem;
  color: #b45309;
}
.rpr-sala__table {
  background: transparent !important;
}

/* ── Transición sala de espera ── */
.sala-fade-enter-active,
.sala-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.sala-fade-enter,
.sala-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>